import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const FINNISH = {
  type: 'fi-FI',
  languageNames: {
    en: 'Englanti',
    no: 'Norja',
    nb: 'Norja',
    de: 'Saksa',
    fr: 'Ranska',
    sv: 'Ruotsi',
    se: 'Ruotsi',
    da: 'Tanska',
    it: 'Italia',
    fi: 'Suomi',
  },
  global: {
    noDataAvailable: 'Ei tietoja saatavilla',
    move: 'Siirrä',
    rotate: 'Kierrä',
    model: 'Malli',
    data: 'Tiedot',
    all: 'Kaikki',
    controls: 'Ohjaus',
    lastUpdated: 'Viimeksi päivitetty',
    noData: 'Ei tietoja',
    custom: 'Mukautettu',
    name: 'Nimi',
    setpoints: 'Setpointit',
    email: 'Sähköposti',
    date: 'Päivä',
    timestamp: 'Aikaleima',
    language: 'Kieli',
    timezone: 'Aikavyöhyke',
    address: 'Osoite',
    street: 'Katu',
    postcode: 'Postinumero',
    city: 'Kaupunki',
    add: 'Lisää',
    country: 'Maa',
    new: 'Uusi',
    from: 'Alkaen',
    until: 'Asti',
    selectStartDate: 'Valitse alkupäivä',
    selectEndDate: 'valitse loppupäivä',
    copied: 'Kopioitu',
    average: 'Keskiarvo',
    min: 'Min',
    max: 'Maks',
    last: 'Viimeisin',
    type: 'Tyyppi',
    role: 'Rooli',
    category: 'Kategoria',
    description: 'Kuvaus',
    status: 'Tila',
    public: 'Julkinen',
    active: 'Aktiivinen',
    inactive: 'Ei aktiivinen',
    hidden: 'Piilotettu',
    visible: 'Näkyvä',
    show: 'Näytä',
    hide: 'Piilota',
    enabled: 'Käytössä',
    disabled: 'Pois käytöstä',
    actionRequired: 'Toimenpide vaaditaan',
    success: 'Onnistui',
    none: 'Ei mitään',
    error: 'Virhe',
    basicInfo: 'Perustiedot',
    information: 'Tiedot',
    display: 'Näkymä',
    save: 'Tallenna',
    saving: 'Tallennetaan…',
    saveSuccess: 'Tallennettu',
    saveError: 'Tallennus epäonnistui',
    search: 'Hae',
    close: 'Sulje',
    confirm: 'Vahvista',
    yes: 'Kyllä',
    no: 'Ei',
    rename: 'Nimeä uudelleen',
    editName: 'Muokkaa nimeä',
    download: 'Lataa',
    open: 'Avaa',
    cancel: 'Peruuta',
    update: 'Päivitä',
    updating: 'Päivitetään...',
    undo: 'Kumoa',
    done: 'Valmis',
    delete: 'Poista',
    discard: 'Hylkää',
    password: 'Salasana',
    login: 'Kirjaudu',
    loginWithAzure: 'Kirjaudu Azurella',
    invalidCredentials: 'Virheelliset tunnistetiedot',
    loginTooManyAttempts:
      'Liian monta kirjautumisyritystä, yritä uudelleen muutaman minuutin kuluttua',
    loginInactiveUser: 'Tämä käyttäjätili ei ole enää aktiivinen',
    loginUnavailable:
      'Kirjautuminen ei onnistu juuri nyt, yritä myöhemmin uudelleen',
    welcome: 'Tervetuloa Sastechiin',
    loginSubtitle: 'Kirjaudu sisään päästäksesi hallintapaneeliin',
    or: 'tai',
    key: 'Avain',
    back: 'Takaisin',
    apply: 'Käytä',
    inDevelopment: 'Kehityksessä',
    notAuthorized: 'Et ole valtuutettu',
    heating: 'Lämmitys',
    cooling: 'Kylmä',
    ventilation: 'Ilmanvaihto',
    climate: 'Sisäilmasto',
    battery: 'Akku',
    batteries: 'Akut',
    capabilities: 'Toiminnot',
    moveTo: 'Siirrä kansioon',
    building: 'Rakennus',
    buildings: 'Rakennukset',
    floor: 'Kerros',
    floors: 'Kerrokset',
    sensors: 'Anturit',
    sensor: 'Anturi',
    controller: 'Ohjain',
    energySource: 'Energialähde',
    session: 'Sessio',
    addDevice: 'Lisää laite',
    device: 'Laite',
    devices: 'Laitteet',
    selectDevice: 'Valitse laite',
    edit: 'Muokkaa',
    serialNumber: 'Sarjanumero',
    trash: 'Roskakori',
    actions: 'Toiminnot',
    restore: 'Palauta',
    emptyTrash: 'Tyhjennä roskakori',
    selectCategory: 'Valitse...',
    create: 'Luo',
    monthChartText: [
      'Tam',
      'Hel',
      'Maa',
      'Huh',
      'Tou',
      'Kes',
      'Hei',
      'Elo',
      'Syy',
      'Lok',
      'Mar',
      'Jou',
    ],
    today: 'Tänään',
    weekdaysShort: ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su'],
    weekdays: [
      'Sunnuntai',
      'Maanantai',
      'Tiistai',
      'Keskiviikko',
      'Torstai',
      'Perjantai',
      'Lauantai',
    ],
    title: 'Otsikko',
    to: 'asti',
    remove: 'Poista',
    inspect: 'Tarkasta',
    compare: 'Vertaa',
    export: 'Vie',
    total: 'Yhteensä',
    activate: 'Aktivoi',
    color: 'Väri',
    text: 'Teksti',
    link: 'Linkki',
    frame: 'Kehys',
    info: 'Info',
    saveChanges: 'Tallenna muutokset',
    sidebarMenu: 'Sivupalkki',
    icons: 'Kuvakkeet',
    ok: 'OK',
    exit: 'Sulje',
    exportImage: 'Vie kuva',
    exportSelected: 'Vie valitut',
    directions: {
      top: 'Ylä',
      bottom: 'Ala',
      right: 'Oikea',
      left: 'Vasen',
      front: 'Etu',
      back: 'Taka',
      isometric: 'Isometrinen',
    },
    switchVendor: 'Vaihda asiakas',
    searchVendors: 'Hae asiakkaita...',
    noVendorsFound: 'Asiakkaita ei löytynyt',
  },
  chart: {
    zoomIn: 'Lähennä',
    zoomOut: 'Loitonna',
    rotate: 'Kierrä',
    fullscreen: 'Koko näyttö',
    rotateTip: 'Napsauta ja vedä kääntääksesi kaaviota',
  },
  data: {
    loading: 'Ladataan...',
    loadingData: 'Ladataan tietoja...',
    noResults: 'Ei tuloksia.',
    error: 'Virhe',
    failedToLoadData: 'Tietojen lataus epäonnistui',
    noDataAvailable: 'Ei tietoja saatavilla',
  },

  general: {
    temperature: 'Lämpötila',
    co2: 'CO₂',
    humidity: 'Kosteus',
    zone: 'Vyöhyke',
    data: 'Data',
    edit: 'Muokkaa',
    analyze: 'Analysoi',
    chartType: 'Kaaviotyyppi',
    toggleSeries: 'Vaihda sarjoja',
    resetFilters: 'Nollaa suodattimet',
    exportData: 'Vie tiedot',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Kirjoita viestisi…',
    send: 'Lähetä',
    unknownUser: 'Tuntematon käyttäjä',
  },
  navigation: {
    dashboard: 'Hallintapaneeli',
    eosDashboard: 'Yleiskatsaus',
    devices: 'Laitteet',
    map: 'Kartta',
    buildings: 'Rakennukset',
    reports: 'Raportit',
    settings: 'Asetukset',
    logout: 'Kirjaudu ulos',
    sastech: 'Sastech-asetukset',
    analytics: 'Analytiikka',
    buildings3D: 'Rakennukset 3D',
    superSettings: 'Sastech',
    buildingInspection: 'Tarkastus',
    expandSidebar: 'Laajenna sivupalkki',
    collapseSidebar: 'Pienennä sivupalkki',
    userCalendar: 'Käyttäjäkalenteri',
    energyLabelLeads: 'Energiamerkintä-liidit',
  },
  reports: {
    title: 'Raportit',
    orderReport: 'Tilaa raportti',
    orderDescription: 'Raportti ilmestyy listaan, kun se on valmis.',
    reportType: 'Raporttityyppi',
    kinds: {
      eos_weekly: 'Viikoittainen energiaraportti',
      eos_monthly: 'Kuukausittainen energiaraportti',
    },
    period: 'Jakso',
    week: 'Viikko {week}',
    reportLanguage: 'Raportin kieli',
    submit: 'Tilaa',
    submitting: 'Tilataan…',
    status: {
      queued: 'Jonossa',
      generating: 'Luodaan',
      completed: 'Valmis',
      failed: 'Epäonnistui',
    },
    exportExcel: 'Lataa Excel',
    exportPdf: 'Lataa PDF',
    makePdf: 'Luo PDF',
    pdfPending: 'PDF luodaan…',
    confirmDeleteTitle: 'Poista raportti',
    confirmDeleteMessage: 'Raportti poistetaan listalta. Tätä ei voi kumota.',
    noReports: 'Ei vielä raportteja. Tilaa ensimmäinen.',
    noSearchHits: 'Yksikään raportti ei vastaa hakua.',
    noMeters: 'Rakennuksella ei ole aktiivisia energiamittareita.',
    duplicateOrder: 'Sama raportti on jo tekeillä.',
    orderError: 'Raporttia ei voitu tilata',
    orderSuccess: 'Raportti on tilattu ja sitä luodaan.',
    deleteError: 'Raporttia ei voitu poistaa',
    pdfError: 'PDF-tiedostoa ei voitu tilata',
    pdfRequested: 'PDF on tilattu ja sitä luodaan.',
    requestedBy: 'Tilaaja',
    ordered: 'Tilattu',
    daysAgo: '{count} päivää sitten',
    sheets: {
      summary: 'Yhteenveto',
      days: 'Päivittäin',
      hours: 'Tunneittain',
      sources: 'Mittarit',
      profile: 'Vuorokausiprofiili',
    },
    excel: {
      parameter: 'Parametri',
      value: 'Arvo',
      unit: 'Yksikkö',
      delivered: 'Toimitettu energia',
      production: 'Oma tuotanto',
      export: 'Viety',
      net: 'Käytetty rakennuksessa',
      baseline: 'Perustaso',
      previousYear: 'Edellinen vuosi',
      co2: 'CO2',
      baselineCo2: 'CO2 perustaso',
      hoursWithData: 'Tunteja datalla',
      meanKW: 'Keskiteho',
      maxKW: 'Korkein tunti',
      maxAt: 'Korkein tunti, ajankohta',
      baseLoadKW: 'Pohjakuorma',
      nightKW: 'Yökuorma 00–05',
      peakHours: 'Tunnit vähintään 90 % maksimista',
      weekday: 'Viikonpäivä',
      time: 'Tunti',
      source: 'Mittari',
      missingHours: 'Puuttuvat tunnit',
      energy: 'Energia',
      co2Factor: 'CO2 kerroin',
      role_delivered: 'toimitettu energia',
      role_production: 'oma tuotanto',
      role_export: 'vienti',
      role_excluded: 'ei laskettu',
    },
  },
  map: {
    addBuildingAtCenter: 'Lisää rakennus kartan keskelle',
  },
  pagination: {
    rowsPerPage: 'Rivejä per sivu',
    rangeSeparator: '/',
  },
  devices: {
    title: 'Laitteen yleiskatsaus',
    reset: 'Nollaa',
    noDevices: 'Laitteita ei löytynyt.',
    unnamed: 'Nimetön laite',
    copySensorTag: 'Kopioi sensoritagi',
    graph: {
      inspect: 'Tarkasta',
      edit: 'Muokkaa',
      chartType: 'Kaaviotyyppi',
      toggleSeries: 'Vaihda sarjoja',
      resetFilters: 'Nollaa suodattimet',
      exportData: 'Vie tiedot',
      noData: 'Ei dataa',
      bar: 'Pylväs',
      line: 'Viiva',
      pie: 'Ympyrä',
      scatter: 'Hajonta',
      radar: 'Tutka',
    },
    categoryFilter: {
      filter: 'Suodata',
      filterByCategory: 'Suodata kategorian mukaan',
      selectAll: 'Valitse kaikki',
      clearAll: 'Tyhjennä kaikki',
      searchCategories: 'Hae kategorioita...',
      noCategories: 'Kategorioita ei löytynyt',
      noData: 'Ei dataa',
      devices: 'laitetta',
      selected: 'Valittu',
      category: 'kategoria',
      categories: 'kategoriaa',
      more: 'lisää',
    },
    detailLevel: {
      label: 'Tietotaso',
      units: {
        minutes: 'Minuuttia',
        minutesShort: 'min',
        day: 'Päivä',
      },
    },
    dateRange: {
      startLabel: 'Alkupäivä',
      endLabel: 'Loppupäivä',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Päivämäärä',
        total: {
          production: 'Kokonais­tuotanto:',
          consumption: 'Kokonaiskulutus:',
        },
        highestPeak: 'Korkein huippu:',
        calculatedPrice: {
          eur: 'Laskettu hinta (EUR):',
          nok: 'Laskettu hinta (NOK):',
        },
      },
    },
  },

  analytics: {
    session: {
      moreActions: 'Lisää toimintoja',
      newSession: 'Uusi sessio',
      unsaved: 'Tallentamattomia muutoksia',
      namePlaceholder: 'Session nimi',
      deleteTitle: 'Poistetaanko sessio?',
      deleteDescription:
        'Tämä poistaa tallennetun session ja sen laitevalinnan pysyvästi.',
      noSessions: 'Ei tallennettuja sessioita',
      discardTitle: 'Hylätäänkö tallentamattomat muutokset?',
      discardDescription:
        'Nykyisessä sessiossa on tallentamattomia muutoksia. Ne menetetään, jos vaihdat.',
    },
    notifications: {
      overlayMissingZone:
        'Rakennukselle ei ole määritetty vyöhykettä. Käytetään oletusta (NO1).',
      overlayMissingRate: 'Valuuttakurssin haku ei onnistunut',
      overlayFetchFailed: 'Päällekkäisten tietojen haku ei onnistunut',
      sessionSaved: 'Sessio tallennettu',
      sessionCreated: 'Sessio luotu',
      sessionDeleted: 'Sessio poistettu',
      sessionSaveFailed: 'Session tallennus ei onnistunut',
      sessionDeleteFailed: 'Session poisto ei onnistunut',
      sessionsLoadFailed: 'Tallennettujen sessioiden lataus ei onnistunut',
      devicesLoadFailed: 'Laitteiden lataus ei onnistunut',
      buildingsLoadFailed: 'Rakennusten lataus ei onnistunut',
      readingsLoadFailed:
        'Yhden tai useamman laitteen mittausten lataus ei onnistunut',
      nameRequired: 'Anna sessiolle nimi ennen tallennusta',
      rangeTooWide:
        'Yli 7 päivän jaksot ovat hitaita tällä näytteenottovälillä. Vaihda Päivittäin parantaaksesi suorituskykyä.',
    },
    title: 'Reaaliaikainen analytiikka & KPI:t',
    pageTitle: 'Analytiikka',
    searchPlaceholder: 'Hae laitteita…',
    buttons: {
      toggleSidebar: 'Näytä/piilota laiteluettelo',
      showAll: 'Näytä kaikki',
      hideAll: 'Piilota kaikki',
      showTrends: 'Näytä trendit',
      hideTrends: 'Piilota trendit',
      clearAll: 'Tyhjennä kaikki',
      export: 'Vie',
    },
    exportMenu: {
      exportAsPNG: 'Vie PNG-muodossa',
      exportAsCSV: 'Vie CSV-muodossa',
    },
    thresholds: {
      max: 'Maks:',
      min: 'Min:',
      aboveThreshold: 'Kynnysarvon yläpuolella',
      belowThreshold: 'Kynnysarvon alapuolella',
    },
    timeAxis: {
      label: 'Aika-akseli',
      actual: 'Todellinen aika',
      timeOfDay: 'Kellonaika',
      dayOfWeek: 'Viikonpäivä',
      dayOfMonth: 'Kuukauden päivä',
      bucket: 'Ryhmittele',
    },
    legend: {
      manage: 'Hallitse',
      overlays: 'Päällekkäiset',
      series: 'Sarjat',
      trends: 'Trendit',
      more: 'lisää',
    },
    overlay: {
      weatherAndElectricity: 'Sää & Sähkö',
      none: 'Ei mitään',
      outsideTemperature: 'Ulkolämpötila',
      elecPrice: 'Sähkön hinta',
      elecPriceFull: 'Sähkön hinta (€/kWh)',
      loadingData: 'Ladataan tietoja...',
    },
    collab: {
      viewingSession: 'katselee tätä sessiota',
      updatedSession: 'päivitti tämän session',
      deletedSession: 'poisti tämän session',
      conflictTitle: 'Joku on tallentanut uudemman version',
      conflictDescription:
        'Joku muu tallensi tämän session muokkauksesi aikana. Lataa heidän versionsa (muutoksesi menetetään) tai korvaa se omallasi.',
      loadTheirs: 'Lataa heidän versionsa',
      overwrite: 'Korvaa',
    },
    picker: {
      wholeBuilding: 'Koko rakennus',
      noClimateSources: 'Ei rakennuksia, joissa on vyöhykkeitä',
      noAveragesData: 'Ei vielä ilmastotietoja',
      noIndoorSensors: 'Rakennuksessa ei ole sisäantureita',
      inSession: 'Sessiossa',
      searchBuildings: 'Hae rakennuksia…',
      noBuildingsMatch: 'Ei vastaavia rakennuksia',
      noWeatherData: 'Ei vielä säätietoja',
    },
    devices: {
      noDevicesMatch: 'Laitteita ei löytynyt',
      unnamedDevice: 'Nimetön laite',
      noDevicesSelected: 'Laitteita ei valittu',
      devicesFound: 'laitetta löytyi',
      noDevicesMatchSearch: 'Yksikään laite ei vastaa hakuasi',
      deviceSelected: 'laite valittu',
      devicesSelected: 'laitetta valittu',
      shown: 'näytetään',
      total: 'yhteensä',
    },
    chart: {
      zoomHint: 'Zoomattu (kaksoisnapsauta palauttaaksesi)',
      loadingChartData: 'Ladataan kaavion tietoja...',
      addDevicesToVisualize: 'Lisää laitteita tietojen visualisoimiseksi',
    },
    liveEvents: {
      title: 'Reaaliaikaiset tapahtumat',
      events: 'tapahtumaa',
      waitingForEvents: 'Odotetaan tapahtumia…',
    },
    modal: {
      weatherIntervalHint: 'Säätiedot ovat tuntitarkkuudella',
      deviceSettings: 'Laiteasetukset',
      addDevices: 'Lisää laitteita',
      clear: 'Tyhjennä',
      startTime: 'Alkuaika',
      endTime: 'Loppuaika',
      samplingInterval: 'Näytteenottoväli',
      dataAggregationGranularity: 'Tietojen yhdistämisen tarkkuus',
      startMustBeBeforeEnd: 'Alun on oltava ennen loppua',
      intervals: {
        fiveMinutes: '5 minuuttia',
        fifteenMinutes: '15 minuuttia',
        oneHour: '1 tunti',
        daily: 'Päivittäin',
      },
    },
    connectionStatus: {
      error: 'VIRHE',
      connected: 'YHDISTETTY',
      connecting: 'YHDISTETÄÄN',
      disconnected: 'YHTEYS KATKAISTU',
    },
  },

  eosDashboard: {
    headerTitle: 'Energiakatsaus',
    energyKnowledge: {
      title: 'Energia-analyysi',
      lastMonth: 'Viime kuukausi',
    },
    building: 'Rakennus',
    selectBuilding: 'Valitse rakennus',
    outdoorTemperature: 'Ulkolämpötila',
    noData: 'Ei tietoja',
    electricityPrice: 'Sähkön hinta',
    electricityPrices: 'Sähkön hinnat',
    noPriceData: 'Ei hintatietoja saatavilla.',
    electricityConsumption: 'Sähkönkulutus',
    baseline: 'Vertailuarvo',
    viewLabel: 'Näkymä:',
    aggregated: 'Koottu',
    meteringPoint: 'Mittauspiste:',
    individualTitle: 'Yksittäiset mittauspisteet',
    eosSourcesTitle: 'Yksittäiset EOS-laitteet',
    footprint: 'CO₂-jalanjälki (vähennys)',
    co2Footprint: 'CO₂-jalanjälki',
    consumption: 'Kulutus',
    avgMaxKwp: 'Keskimääräinen maksimi kWp',
    higher: 'Korkeampi',
    lower: 'Matalampi',
    normal: 'Normaali',
    priceWord: 'hinta',
    vsAverage: 'Keskiarvoon verrattuna',

    baselineChart: {
      total: 'Yhteensä',
      average: 'Keskiarvo',
      leftAxis: 'kWh (Kulutus)',
      rightAxis: 'kWp (Keskimääräinen maksimi)',
      co2Avg: 'CO₂ Keskiarvo',
      missingData: 'Puuttuvat tiedot',
      missingDataDescription: 'Arvot puuttuvat tältä kuukaudelta',
    },
    energyLabel: {
      title: 'Dynaaminen energialuokka',
      withoutSastech: 'Virallinen luokka',
      withSastech: 'Dynaaminen luokka',
      deliveredEnergy: 'Laskettu toimitettu energia',
      insufficientData:
        'Vain {months} kuukauden tiedot saatavilla. Luokka ei välttämättä ole edustava.',
      noFloorArea: 'Rakennuksen nettokäyttöpinta-alaa ei ole asetettu.',
      noBuildingCategory:
        'Rakennusluokkaa ei ole asetettu tälle rakennukselle.',
      fossilFuelShare: 'Sähkön/öljyn/kaasun osuus',
      reduction: 'Vähennys',
      floorArea: 'Lattiapinta-ala',
      annualConsumption: 'Vuosittainen',
      energyGrade: 'Energialuokka',
      labels: {
        A: 'Erittäin energiatehokas',
        B: 'Energiatehokas',
        C: 'Kohtalainen tehokkuus',
        D: 'Keskimääräistä heikompi',
        E: 'Heikko tehokkuus',
        F: 'Hyvin heikko tehokkuus',
        G: 'Tehottomin',
      },
    },
    kpiSection: {
      noChange: '0.0',

      units: {
        kWh: 'kWh',
        kg: 'kg',
        kgCo2: 'kg CO₂',
        krPerKWh: 'kr/kWh',
        degC: '°C',
      },

      trend: {
        increaseSign: '+{percent}%',
        decreaseSign: '-{percent}%',
        neutral: '0.0',
        aboveAverage: 'Yli',
        belowAverage: 'Alle',
        atAverage: 'Tasan',
        averageThisPeriod: 'keskimäärin tällä jaksolla',
      },

      consumption: {
        title: 'Kokonaiskulutus',
        value: '{value} {unit}',
        subtitle: {
          increased: 'Kasvanut {delta} {unit}',
          reduced: 'Vähentynyt {delta} {unit}',
          noChange: 'Ei muutosta kulutuksessa',
        },
        detail: 'Energian kulutus viime {periodLabel}',
      },

      co2: {
        title: 'Kokonais-hiilijalanjälki',
        value: '{value} {unit}',
        subtitle: {
          reduced: 'Vähennetty {delta} {unit}',
          increased: 'Kasvanut {delta} {unit}',
          noChange: 'Ei muutosta päästöissä',
          noBaseline: 'Ei vertailutietoja saatavilla',
        },
        detail: 'Hiilijalanjälki viime {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Astepäiväkorjattu kulutus',
      },

      estate: {
        title: 'Rakennukset ja lähteet',
        value: '{count} rakennusta',
        subtitle: '{count} kokonaismäärä yhteensä',
        detail: 'Tällä hetkellä {count} aktiivista laitetta',
      },

      price: {
        title: 'Nykyinen hinta',
        value: '{value} {unit}',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Sähkön hinta juuri nyt',
      },

      temperature: {
        title: 'Lämpötila',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Nykyiset sääolosuhteet',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Kulutusvertailu - viime vuosi vs kuluvan vuoden alusta',
        baseLineLabel: 'Vertailuarvo',
        peakHourlyLabel: 'Korkein huippu',
      },
      consumptionSavings: {
        title: `Kulutussäästöt - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Yhteensä',
      totalEnergyConsumption: 'Kokonaisenergiankulutus',
      totalElectricityConsumption: 'Sähkön kokonaiskulutus',
      energyConsumption: 'Energiankulutus',
      electricityConsumption: 'Sähkönkulutus',
      noDataForSelectedPeriod: 'Ei tietoja valitulta ajanjaksolta',
      meteringPointTitle: 'Mittauspiste: {id}',
      sourceTitle: 'Lähde: {id}',
      unknownLabel: 'Tuntematon',
      unknownIdLabel: 'Tuntematon tunniste',
      powerFactorLabel: 'Tehokerroin Cos φ',
      powerFactorWarning:
        'Alle 0,95:n tehokerroin voi aiheuttaa tariffilisämaksuja',
      renameDialog: {
        title: 'Nimeä mittauspiste uudelleen',
        label: 'Näyttönimi',
        helpTextPrefix: 'Alkuperäinen mittauspisteen tunniste',
      },
      errors: {
        loadAggregatedData: 'Yhdistettyjen tietojen lataaminen epäonnistui',
        loadFilteredData: 'Suodatettujen tietojen lataaminen epäonnistui',
        fetchDisplayName: 'Näyttönimitietojen hakeminen epäonnistui',
        invalidDisplayName: 'Anna kelvollinen näyttönimi',
        renameFailed: 'EOS-laitteen uudelleennimeäminen epäonnistui',
        renameUnknown: 'EOS-laitteen uudelleennimeämisen aikana tapahtui virhe',
        noDataToExport: 'Ei vietäviä tietoja',
        exportFailedTitle: 'Vienti epäonnistui',
        exportFailedPrefix: 'Tietojen vienti epäonnistui',
        unknownError: 'Tuntematon virhe',
        enterValidDisplayName: 'Anna kelvollinen näyttönimi',
        validationErrorTitle: 'Validointivirhe',
      },
      tooltip: {
        electricityElhub: 'Sähkö',
        reactiveEnergy: 'Loisteenergia',
        buildingsLabel: 'Rakennukset',
        meteringPointsLabel: 'Mittauspisteet',
        districtHeating: 'Lämmitys',
        solarPv: 'Tuotettu aurinkosähkö',
        exportedElectricity: 'Verkkoon syötetty sähkö',
      },
    },
    co2BarChart: {
      baseline: 'Vertailuarvo',
      legendBaseline: 'Baseline',
      currentValues: 'Nykyiset arvot',
      co2Emissions: 'CO₂-päästöt',
      dailyEmissions: 'Päivittäiset päästöt',
      monthlyEmissions: 'Kuukausittaiset päästöt',
      months: [
        'Tammikuu',
        'Helmikuu',
        'Maaliskuu',
        'Huhtikuu',
        'Toukokuu',
        'Kesäkuu',
        'Heinäkuu',
        'Elokuu',
        'Syyskuu',
        'Lokakuu',
        'Marraskuu',
        'Joulukuu',
      ],
      goal: 'Tavoite',
    },
    chartMenu: {
      rename: 'Nimeä uudelleen',
      exportExcel: 'Vie Excel-muodossa',
      exportCSV: 'Vie CSV-muodossa',
    },
    periodOptions: {
      '3days': {
        label: 'Viimeiset 3 päivää',
        mobileLabel: '3 päivää',
        chartLabel: '3 päivää',
      },
      '30days': {
        label: 'Viimeiset 30 päivää',
        mobileLabel: '30 päivää',
        chartLabel: '30 päivää',
      },
      '3months': {
        label: 'Viimeiset 3 kuukautta',
        mobileLabel: '3 kuukautta',
        chartLabel: '3 kuukautta',
      },
    },
    chartSubtitle: {
      today: 'Yhteensä tänään',
      oneDay: 'Yhteensä 1 päivä',
      days: 'Yhteensä {days} päivää',
      oneWeek: 'Yhteensä 1 viikko',
      weekAndDays: 'Yhteensä 1 viikko ja {days} päivä(ä)',
      weeks: 'Yhteensä {weeks} viikkoa',
      weeksAndDays: 'Yhteensä {weeks} viikkoa ja {days} päivä(ä)',
      months: 'Yhteensä {months} kuukautta',
      monthsAndDays: 'Yhteensä {months} kuukautta ja {days} päivä(ä)',
      monthsAndWeeks: 'Yhteensä {months} kuukautta ja {weeks} viikko(a)',
    },
    datePicker: {
      startLabel: 'Alku',
      endLabel: 'Loppu',
    },
    weatherTemperature: {
      noData: 'Säätietoja ei saatavilla',
      headerTitle: 'Sääennuste',
      headerSubtitle: 'Ennuste',
      tooltip: {
        conditions: 'Olosuhteet',
        temperature: 'Lämpötila',
        wind: 'Tuuli',
        windDirection: 'Tuulen suunta',
        pressure: 'Ilmanpaine',
        cloudCover: 'Pilvisyys',
        fog: 'Sumu',
        uvIndex: 'UV-indeksi',
        precipitation: 'Sademäärä seuraavan tunnin aikana',
      },
      stats: {
        min: 'Min',
        avg: 'Kesk.',
        max: 'Maks',
        current: 'Nyt',
      },
    },
    tempTrend: {
      stable: 'Ulkolämpötila vakaa',
      graduallyRising: 'Lämpötila nousee vähitellen',
      graduallyFalling: 'Lämpötila laskee vähitellen',
      rising: 'Ulkolämpötila nousee',
      falling: 'Ulkolämpötila laskee',
    },
    noDataForPeriod: 'Ei energiatietoja valitulle ajanjaksolle',
    totalEnergy: 'Kokonaisenergia',
    filters: {
      noMatch: 'Yksikään solmu ei vastaa kaikkia valittuja luokkia',
    },
    staleData: {
      warningText: 'eilisen tiedot eivät ole saatavilla',
      showingDataFrom: 'Näytetään tiedot päivältä',
    },
    sankey: {
      noData: 'Sankey-tietoja ei saatavilla.',
      searchNodes: 'Hae solmuja...',
      selectedNodes: 'Valitut solmut',
      csvValue: 'Arvo (kWh)',
      csvDeviceId: 'Laite-ID',
    },
  },

  superSettings: {
    securityLog: {
      title: 'Tietoturvaloki',
      levelBadge: 'Taso 10',
      intro:
        'Kirjautumiset, muutokset, tietojen käyttö ja API-käyttö kaikilta asiakkailta. Kirjautumiset, muutokset ja tietojen käyttö säilytetään 90 päivää, API-käyttö 30 päivää.',
      error: 'Tietoturvalokia ei voitu ladata.',
      tabs: {
        overview: 'Yleiskatsaus',
        logins: 'Kirjautumiset',
        changes: 'Muutokset',
        reads: 'Tietojen käyttö',
        usage: 'Käyttö',
        sessions: 'Istunnot',
      },
      filters: {
        period: 'Ajanjakso',
        last24h: 'Viimeiset 24 tuntia',
        last7d: 'Viimeiset 7 päivää',
        last30d: 'Viimeiset 30 päivää',
        last90d: 'Viimeiset 90 päivää',
        custom: 'Mukautettu',
        vendor: 'Asiakas',
        allVendors: 'Kaikki asiakkaat',
        exportCsv: 'Vie CSV',
        refresh: 'Päivitä',
      },
      totals: {
        logins: 'Kirjautumiset',
        loginsHint: '{users} käyttäjää, {ips} IP-osoitetta',
        reads: 'Tietojen käyttö',
        readsHint: '{users} käyttäjää',
        readsTooltip:
          'Käyttäjäluetteloiden, asiakasluetteloiden, liidien ja lokien luvut',
        failedLogins: 'Epäonnistuneet kirjautumiset',
        rateLimitedHint: '{count} nopeusrajoituksen pysäyttämää',
        changes: 'Muutokset',
        deletesHint: '{count} poistoa',
        accessChanges: 'Käyttöoikeusmuutokset',
        accessHint: 'Tasot, asiakaskäyttöoikeudet, Entra ID',
        requests: 'API-pyynnöt',
        requestsHint: '{users} aktiivista käyttäjää',
        compromised: 'Mahdollisesti vaarantuneet',
        compromisedHint: 'Tarkistettavat tilit',
        unknownOutcome:
          '{count} kirjautumista ajalta ennen tulosten tallennusta lasketaan erikseen.',
        truncated:
          'Ajanjakso on suuri; vain ensimmäiset 20 000 merkintää tarkistettiin.',
      },
      attention: {
        title: 'Vaatii huomiota',
        empty: 'Mikään ei vaadi huomiota tällä ajanjaksolla.',
        high: 'Korkea',
        medium: 'Keskitaso',
        low: 'Matala',
        showMore: 'Näytä kaikki {count}',
      },
      compromised: {
        title: 'Mahdollisesti vaarantuneet tilit',
        empty: 'Mikään tili ei näytä merkkejä vaarantumisesta.',
        help: 'Käyttöä, johon ihminen ei pysty, tai yksi istunto käytössä useasta paikasta yhtä aikaa.',
      },
      chart: {
        title: 'Kirjautumiset päivittäin',
        success: 'Onnistuneet',
        failed: 'Epäonnistuneet',
        rateLimited: 'Nopeusrajoitetut',
      },
      sensitive: {
        title: 'Viimeisimmät käyttöoikeusmuutokset',
        empty: 'Ei käyttöoikeusmuutoksia tällä ajanjaksolla.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} epäonnistunutta kirjautumista käyttäjälle {who}, sitten onnistunut kirjautuminen',
        failedLogins: '{count} epäonnistunutta kirjautumista käyttäjälle {who}',
        failedLoginsIp:
          '{count} epäonnistunutta kirjautumista osoitteesta {ip}, {accounts} tiliä vastaan',
        rateLimited:
          '{count} pysäytettyä kirjautumisyritystä käyttäjälle {who}',
        newIp: '{who} kirjautui uudesta IP-osoitteesta ({ip})',
        levelRaised: '{by} nosti käyttäjän {who} tasolta {old} tasolle {new}',
        accessChange: '{by} muutti käyttäjän {who} käyttöoikeuksia ({fields})',
        userDeleted: '{by} poisti käyttäjän {who}',
        massDelete: '{who} poisti {count} tietuetta 10 minuutin sisällä',
        requestBurst: '{who} teki {count} pyyntöä minuutissa',
        alwaysOn: '{who} oli aktiivinen {count} tuntia vuorokaudessa',
        parallelLocations:
          'Tiliä {who} käytettiin {count} IP-osoitteesta yhtä aikaa',
        parallelDevices: 'Tiliä {who} käytettiin {count} laitteelta yhtä aikaa',
        robotRhythm:
          '{who} teki pyyntöjä koneellisen tasaisesti {count} minuutin ajan',
        changeBurst: '{who} teki {count} muutosta 10 minuutin sisällä',
        vendorHopping: '{who} työskenteli {count} asiakkaalla tunnin sisällä',
        readBurst:
          '{who} luki kriittisiä tietoja {count} kertaa 10 minuutin sisällä',
        unknown: 'Tuntematon hälytys',
        someone: 'tuntematon tili',
        occurrences: '{count} kertaa ajanjaksolla',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Kirjautuminen monen virheen jälkeen',
        failedLogins: 'Monta epäonnistunutta kirjautumista',
        failedLoginsIp: 'Virheitä tuottava IP',
        rateLimited: 'Nopeusrajoitettu',
        newIp: 'Uusi IP-osoite',
        levelRaised: 'Tasoa nostettu',
        accessChange: 'Käyttöoikeus muutettu',
        userDeleted: 'Käyttäjä poistettu',
        massDelete: 'Massapoisto',
        requestBurst: 'Pyyntöpiikki',
        alwaysOn: 'Aina päällä',
        parallelLocations: 'Useita paikkoja yhtä aikaa',
        parallelDevices: 'Useita laitteita yhtä aikaa',
        robotRhythm: 'Koneellinen tahti',
        changeBurst: 'Muutospiikki',
        vendorHopping: 'Asiakashyppely',
        readBurst: 'Massaluku',
      },
      logins: {
        time: 'Aika',
        outcome: 'Tulos',
        method: 'Tapa',
        account: 'Tili',
        vendor: 'Asiakas',
        ip: 'IP-osoite',
        device: 'Laite',
        allOutcomes: 'Kaikki tulokset',
        allFailures: 'Kaikki virheet',
        allMethods: 'Kaikki tavat',
        searchEmail: 'Hae sähköpostia',
        searchIp: 'IP-osoite',
        filterByIp: 'Näytä tämän IP:n kirjautumiset',
        filterByAccount: 'Näytä tämän tilin kirjautumiset',
        empty: 'Suodattimia vastaavia kirjautumisia ei ole.',
      },
      outcomes: {
        success: 'Onnistui',
        wrong_password: 'Väärä salasana',
        unknown_user: 'Tuntematon käyttäjä',
        inactive: 'Poistettu käytöstä',
        invalid_input: 'Virheellinen syöte',
        rate_limited: 'Nopeusrajoitettu',
        unknown_vendor: 'Tuntematon tenant',
        invalid_session: 'Virheellinen istunto',
        unknown: 'Ei tallennettu',
      },
      methods: {
        password: 'Salasana',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Aika',
        action: 'Toiminto',
        collection: 'Kokoelma',
        record: 'Tietue',
        by: 'Tekijä',
        vendor: 'Asiakas',
        endpoint: 'Pyyntö',
        history: 'Historia',
        allActions: 'Kaikki toiminnot',
        create: 'Luotu',
        update: 'Päivitetty',
        delete: 'Poistettu',
        collectionPlaceholder: 'Kokoelma, esimerkiksi users',
        fieldPlaceholder: 'Kenttä, esimerkiksi level',
        empty: 'Suodattimia vastaavia muutoksia ei ole.',
        filterByUser: 'Näytä tämän käyttäjän muutokset',
      },
      reads: {
        time: 'Aika',
        user: 'Käyttäjä',
        area: 'Mitä',
        vendor: 'Asiakas',
        ip: 'IP-osoite',
        device: 'Laite',
        allAreas: 'Kaikki paitsi tietoturvaloki',
        everything: 'Kaikki, myös tietoturvaloki',
        searchIp: 'IP-osoite',
        filterByUser: 'Näytä tämän käyttäjän luvut',
        filterByIp: 'Näytä luvut tästä IP-osoitteesta',
        empty: 'Mikään luku ei vastaa suodattimia.',
        note: 'Käyttäjäluetteloiden, asiakasluetteloiden, liidien ja lokien luvut, säilytetään 90 päivää.',
      },
      readAreas: {
        vendors: 'Asiakasluettelo',
        users: 'Käyttäjäluettelo',
        alarmUsers: 'Hälytyskäyttäjät',
        energyLabelLeads: 'Energiatodistusliidit',
        enerskyAccess: 'Enersky-pääsy',
        feedback: 'Palaute',
        requestLogs: 'Pyyntölokit',
        securityLog: 'Tietoturvaloki',
        other: 'Muu',
      },
      usage: {
        user: 'Käyttäjä',
        requests: 'Pyynnöt',
        peak: 'Huippu minuutissa',
        activeMinutes: 'Aktiiviset minuutit',
        ips: 'IP-osoitteet',
        devices: 'Laitteet',
        vendors: 'Asiakkaat',
        flags: 'Liput',
        flaggedOnly: 'Vain liputetut käyttäjät',
        compromisedBadge: 'Mahdollisesti vaarantunut',
        empty: 'Ei API-käyttöä tällä ajanjaksolla.',
        note: 'API-käyttö säilytetään 30 päivää.',
      },
      sessions: {
        user: 'Käyttäjä',
        rights: 'Oikeudet',
        method: 'Tapa',
        ip: 'IP-osoite',
        device: 'Laite',
        started: 'Kirjautunut',
        lastSeen: 'Viimeksi nähty',
        status: 'Tila',
        open: 'Avoin',
        revoked: 'Lopetettu',
        expired: 'Vanhentunut',
        idle: 'Toimeton',
        level: 'Taso {level}',
        tenants: '+{count} asiakasta',
        openOnly: 'Vain avoimet istunnot',
        revoke: 'Lopeta',
        revokeTitle: 'Lopetetaanko tämä istunto?',
        revokeText: 'Käyttäjän {who} istunto ({method}, {ip}) lopetetaan.',
        cancel: 'Peruuta',
        revokeFailed: 'Istuntoa ei voitu lopettaa.',
        empty: 'Suodattimia vastaavia istuntoja ei ole.',
        note: 'Istunto päättyy {absolute} tuntia kirjautumisen jälkeen tai {idle} tunnin käyttämättömyyden jälkeen. Istunnot säilytetään 90 päivää.',
        notEnforced:
          'Istunnot tallennetaan, mutta niitä ei vielä valvota. Lopettaminen merkitsee istunnon päättyneeksi; käyttäjä kirjataan ulos, kun valvonta otetaan käyttöön.',
      },
      history: {
        title: 'Tietueen historia',
        empty: 'Tälle tietueelle ei ole tallennettuja muutoksia.',
        close: 'Sulje',
        open: 'Näytä tämän tietueen historia',
      },
    },
    areasMenu: {
      securityLog: 'Tietoturvaloki',
      createDashboard: 'Luo hallintapaneeli',
      feedback: 'Palaute',
      projects: 'Projektit',
      icMeter: 'IC-mittari',
      lakeSensors: 'Järvisensorit',
      eosDevices: 'EOS-laitteet',
      deviceMapping: 'Laitteenkartoitus',
      energyLabeling: 'Energiamerkintä',
      alarmSystems: 'Hälytysjärjestelmät',
      enerskyAccess: 'Enersky-käyttö',
    },
    dataQuality: {
      title: 'Tietolaadun tarkastaja',
      subtitle:
        'Reaaliaikainen yleiskatsaus kaikista anturiryhmistä ja laitteiden datan tilasta.',
      noLakes: 'Anturiryhmiä ei löydy',
      noDevices: 'Ei laitteita',
      allReporting: 'Kaikki raportoivat',
      missing: 'puuttuu',
      device: 'laite',
      devices: 'laitetta',
      missingData: 'Puuttuvat tiedot',
    },
    createDashboard: {
      header: 'Uusi asiakas–hallintapaneeli',
      sections: {
        companyDetails: 'Yrityksen tiedot',
        address: 'Osoite',
        contactDetails: 'Yhteystiedot',
      },
      fields: {
        companyName: 'Yrityksen nimi',
        organizationNumber: 'Y-tunnus',
        street: 'Katu',
        city: 'Kaupunki',
        postcode: 'Postinumero',
        country: 'Maa',
        email: 'Sähköposti',
        phoneNumber: 'Puhelinnumero',
        timezone: 'Asiakkaan aikavyöhyke',
      },
      helperText: {
        organizationNumber: 'Yrityksen rekisterinumero',
        timezone: 'Valitse asiakkaan paikallinen aikavyöhyke',
      },
      buttons: {
        cancel: 'Peruuta',
        createClient: 'Luo asiakas',
      },
    },
    sastechFeedback: {
      title: 'Sastech Palaute',
      table: {
        title: 'Palautteet',
        message: 'Viesti',
        actions: 'Toiminnot',
        resolved: 'Ratkaistu',
        resolvedBy: 'tekijä',
        unResolved: 'Ratkaisematon',
        filter: 'Suodatin',
        developerFeedback: 'Kehittäjän palaute',
        comment: 'Kommentti',
        assignDeveloper: 'Määritä kehittäjä',
        suggestedAction: 'Ehdotettu toimenpide',
        tags: 'Tagit',
        noTagsProvided: 'Tageja ei annettu',
        vote: 'Äänestä',
        resolvedTicketsThisWeek: 'Tällä viikolla ratkaistut tiketit',
        last7Days: 'Viimeiset 7 päivää',
        newTicketsThisWeek: 'Uudet tiketit tällä viikolla',
        featureTicketsThisWeek: 'Ominaisuustiketit tällä viikolla',
        bugTicketsThisWeek: 'Virhetiketit tällä viikolla',
        resolvedTickets: 'Ratkaistut tiketit',
      },
      buttons: {
        resolve: 'Ratkaise',
        save: 'Tallenna vastaus',
      },
      confirm: {
        resolve: 'Haluatko varmasti merkitä viestin ratkaistuksi?',
        delete: 'Haluatko varmasti poistaa tämän viestin?',
      },
      details: {
        browserInfo: 'Selain­tiedot:',

        device: 'Laite',

        operatingSystem: 'Käyttöjärjestelmä',
        path: 'Polku',
        resolution: 'Resoluutio',
        na: 'ei saatavilla',
        screenshotAlt: 'kuvakaappaus',
      },
    },
    alarmSystems: {
      titleEdit: 'Muokkaa hälytysjärjestelmää',
      accordion: {
        details: 'Hälytyksen tiedot',
        heartbeat: 'Heartbeat-tiedot',
        notification: 'Ilmoitus­asetukset',
        connectedDevices: 'Yhdistetyt laitehälytykset',
      },
      fields: {
        systemName: 'Hälytysjärjestelmän nimi',
        description: 'Kuvaus',
        location: 'Sijainti',
        key: 'Avain',
      },
      heartbeat: {
        explanation:
          'Heartbeat-väli on sekunteina ilmoitusten välillä, jotka hälytysjärjestelmä lähettää palvelimelle. Tämä signaali osoittaa, että järjestelmä on toiminnassa. Jos palvelin ei saa signaalia määräajassa, se voi viitata ongelmaan järjestelmässä.',
        monitor: 'Heartbeat-valvonta',
        hours: 'Tunnit',
        minutes: 'Minuutit',
        seconds: 'Sekunnit',
      },
      notification: {
        type: 'Ilmoitustyyppi',
        selectType: 'Valitse ilmoitustyyppi',
        options: {
          email: 'Sähköposti',
          sms: 'SMS',
        },
        recipient: 'Ilmoituksen vastaanottaja',
        recipients: 'Ilmoituksen vastaanottajat',
        selectUser: 'Valitse käyttäjä',
        orAddManually: 'Tai lisää sähköposti tai puhelinnumero manuaalisesti:',
        addRecipient: 'Lisää vastaanottaja',
        contact: 'Sähköposti / puhelinnumero',
        minimumSeverity: 'Vähimmäisvakavuus',
        severityLevels: {
          1: 'Info',
          2: 'Varoitus',
          3: 'Vähäinen',
          4: 'Merkittävä',
          5: 'Kriittinen',
        },
        errors: {
          empty: 'Vastaanottaja ei voi olla tyhjä',
          duplicate: 'Vastaanottaja on jo listalla',
          invalidEmail: 'Virheellinen sähköpostiosoite',
          selectTypeFirst: 'Valitse ensin ilmoitustyyppi',
          enterEmail: 'Anna sähköpostiosoite',
          enterMobile: 'Anna puhelinnumero',
        },
      },
      connectedDevices: {
        empty: 'Ei laitehälytyksiä liitettynä tähän hälytysjärjestelmään.',
        unnamed: 'Nimetön hälytys',
      },
      titleCreate: 'Luo hälytysjärjestelmä',
      confirmDelete: 'Haluatko varmasti poistaa tämän hälytysjärjestelmän?',
      list: {
        new: 'Uusi',
        search: 'Hae...',
        empty: 'Hälytysjärjestelmiä ei löytynyt',
      },
      updatedSuccess: 'Hälytysjärjestelmä päivitetty onnistuneesti',
      createdSuccess: 'Hälytysjärjestelmä luotu onnistuneesti',
      deletedSuccess: 'Hälytysjärjestelmä poistettu onnistuneesti',
      updateError: 'Virhe hälytysjärjestelmän päivityksessä',
      createError: 'Virhe hälytysjärjestelmän luonnissa',
      deleteError: 'Virhe hälytysjärjestelmän poistossa',
      fetchError: 'Virhe hälytysjärjestelmien haussa',
      fetchLogsError: 'Virhe hälytyslokien haussa',
    },
    enerskyAccess: {
      list: {
        header: 'Enersky-käyttöoikeustietueet',
        description:
          'Hallitse asiakkaiden tiedonjaon käyttöoikeuksia ja sopimustilaa',
        tableTitle: 'Käyttöoikeustietueet',
        addButton: 'Luo tietue',
        emptyState: 'Tietueita ei löytynyt.',
        searchPlaceholder: 'Etsi olemassa olevia tietueita...',
        backButton: 'Takaisin tietueisiin',
      },
      columns: {
        vendor: 'Toimittaja',
        customer: 'Asiakas',
        status: 'Tila',
      },
      validation: {
        missingVendor: 'Vendor is required.',
        missingFirstName: 'First name is required.',
        missingLastName: 'Last name is required.',
        missingEmail: 'Email must be provided and in correct format.',
        missingCompanyName: 'Company name is required for business customers.',
        missingOrganizationNumber: 'Organization number is required.',
        missingNationalId: 'National ID is required.',
      },
      feedback: {
        save: {
          missingInfoTitle: 'Puuttuvia tietoja',
          missingInfoMessage: 'Täytä kaikki pakolliset kentät.',
          createSuccessTitle: 'Rekisteröinti luotu',
          createSuccessMessage:
            'Rekisteröinti luotu ja sopimussähköposti lähetetty.',
          updateSuccessTitle: 'Päivitetty',
          updateSuccessMessage: 'Toimittaja vaihdettiin.',
          errorTitle: 'Virhe',
          errorMessage: 'Tallennus epäonnistui.',
          duplicateEndUser: 'Tämä asiakas on jo Enerskyssä.',
        },
        refresh: {
          mpidsTitle: 'Tilaukset päivitetty',
          mpidsMessage: 'MPID-tilat päivitettiin.',
          statusTitle: 'Tila päivitetty',
          statusMessage: 'Tietueen tila ja MPID:t päivitettiin.',
          errorTitle: 'Virhe',
          errorMessage: 'Tietojen päivittäminen epäonnistui.',
        },
        resend: {
          title: 'Sähköposti lähetetty',
          message: 'Sopimussähköposti lähetettiin uudelleen asiakkaalle.',
          errorTitle: 'Virhe',
          errorMessage: 'Sopimussähköpostin uudelleenlähetys epäonnistui.',
        },
        history: {
          title: 'Historiatietopyyntö jonossa',
          message: 'Tiedot lisättiin jonoon.',
          errorTitle: 'Virhe',
          errorMessage: 'Lukeman lisääminen jonoon epäonnistui.',
        },
        delete: {
          successTitle: 'Tietue poistettu',
          successMessage: 'Enersky-käyttöoikeustietue on poistettu.',
          errorTitle: 'Virhe',
          errorMessage: 'Tietueen poistaminen epäonnistui.',
        },
      },
      editEnerskyAccess: {
        labels: {
          basicInfo: 'Perustiedot',
          vendor: 'Toimittaja',
          firstName: 'Etunimi',
          lastName: 'Sukunimi',
          email: 'Sähköposti',
          companyName: 'Yrityksen nimi',
          privatePerson: 'Yksityishenkilö',
          nationalId: 'Henkilötunnus',
          organizationNumber: 'Y-tunnus',
          systemInfo: 'Enersky-käyttöoikeustietueen tiedot',
          accessUrl: 'Pääsy-URL',
          requestId: 'Pyyntötunnus',
          errorMessage: 'Virheviesti',
          mpidSection: 'Mittauspisteet (MPID)',
          mpid: 'MPID',
          meterNumber: 'Mittarinumero',
          address: 'Osoite',
          description: 'Kuvaus',
          priceArea: 'Hinta-alue',
          status: 'Tila',
          actions: 'Toiminnot',
          deleteConfirmMessage: 'Haluatko varmasti poistaa tämän tietueen?',
        },
        buttons: {
          resendLink: 'Lähetä linkki uudelleen',
          refreshSubscriptions: 'Päivitä tilaukset',
          readHistoricalData: 'Hae historiatiedot',
        },
        status: {
          unknown: 'Tuntematon tila',
        },
        none: 'Ei mitään',
        unknownError: 'Tuntematon virhe',
      },
      status: {
        Pending: 'Odottaa',
        'Contract email sent': 'Sopimussähköposti lähetetty',
        'Contract link requested': 'Sopimuslinkki pyydetty',
        Completed: 'Valmis',
        Error: 'Virhe',
        Unknown: 'Tuntematon tila',
      },
    },

    chirpStackKeys: {
      title: 'Tuodut avaintiedostot',
      addButton: 'Tuo avaimet',
      columns: {
        fileName: 'Tiedostonimi',
        uploadedAt: 'Ladattu',
        importedCount: 'Tuodut määrät',
      },
      importFile: 'Tuo ChirpStack-avaintiedosto',
      preview: {
        title: 'Esikatselu',
        noRows: 'Ei esikatselurivejä.',
        close: 'Sulje',
        cancel: 'Peruuta',
        confirm: 'Vahvista tuonti',
      },
      feedback: {
        loadError: 'Tiedostojen lataaminen epäonnistui',
        previewError: 'Esikatselu epäonnistui',
        invalidExcel: 'Virheellinen Excel-tiedosto.',
        missingFile: 'Alkuperäinen tiedosto puuttuu, valitse uudelleen',
        importSuccess: 'Tuonti onnistui',
        importError: 'Tuonti epäonnistui',
      },
    },

    icMeterData: 'IC-mittaritiedot',
    buildingSensorData: 'Rakennussensoreiden tiedot',
    eosSensorData: 'EOS-anturidata',
    protocol: 'Viestintäprotokolla',
  },
  buildings: {
    sidebar: {
      modifyToggle: 'Muokkaa',
      editBuildingTitle: 'Muokkaa rakennusta',
      buildingOverviewTitle: 'Rakennuksen yleiskatsaus',
      editZoneTitle: 'Muokkaa aluetta',
      outdoorTemperatureTitle: 'Ulkolämpötila',
      indoorClimateTitle: 'Sisäilmasto',
      buildingTemperature: 'Rakennuksen lämpötila',
      floorTemperature: 'Kerroksen lämpötila',
      outdoorTempLabel: 'Ulkölämpötila:',
      electricityPriceLabel: 'Sähkön hinta:',
      energyLabel: 'Energialuokka:',
      noData: 'Ei tietoja',
      aspaTitle: 'ASPA-asetusarvo',
      zoneFloors: {
        selectFloorLabel: 'Valitse alueen kerros:',
        selectBuildingFloorLabel: 'Valitse rakennuksen kerros:',
        changeFloor: '- Vaihda kerrosta -',
        addFloor: 'Lisää kerros',
        groundFloor: 'Katutasokerros',
      },
    },
    aspa: {
      title: 'ASPA-asetukset',
      noPayload: 'ASPA-tietoja ei löytynyt tälle rakennukselle.',
      avgTemp: 'Keskilämpötila',
      acrossAllZones: 'Kaikissa vyöhykkeissä',
      highestZoneTemp: 'Korkein vyöhykelämpö',
      peakZoneReading: 'Huippuvyöhykelukema',
      lastUpdated: 'Viimeksi päivitetty',
      payloadsReceived: 'datapakettia vastaanotettu',
      setpointOverview: 'Asetusarvon yleiskatsaus',
      hourView: '24 tunnin näkymä',
      hourOfDay: 'Vuorokauden tunti',
      dailySetpoint: 'Päivittäinen asetusarvo (°C)',
      liveSetpoint: 'Nykyinen asetusarvo (°C)',
      avg: 'Ka.',
      peak: 'Huippu',
      trends: 'Trendit',
      temperature: 'Lämpötila',
      humidity: 'Kosteus',
      noTrendData: 'Ei trenditietoja.',
      recommendations: 'Suositukset',
      noRecommendations: 'Suosituksia ei löytynyt.',
      actionKeys: {
        cool: 'Jäähdytys',
        coolingLevel: 'Jäähdytystaso',
        preCool: 'Esijäähdytys',
        heat: 'Lämmitys',
        heatingLevel: 'Lämmitystaso',
        preHeat: 'Esilämmitys',
      },
      items: 'kohdetta',
      on: 'Päällä',
      off: 'Pois',
      samples: 'näytettä',
      trendPeriod: 'Viimeiset 2 tuntia',
    },
    details: {
      header: 'Rakennuksen tiedot',
      form: {
        buildingName: 'Rakennuksen nimi',
        active: 'Aktiivinen',
        buildingInformation: 'Rakennuksen tiedot',
        buildingType: 'Rakennustyyppi (NS-standardi)',
        buildingCategory: 'Rakennusluokka',
        constructionYear: 'Rakennusvuosi',
        numberOfFloors: 'Kerrosten lukumäärä',
        netUsableFloorArea: 'Nettokäyttöpinta-ala (m²)',
        gridRegion: 'Sähköalue',
        selectGridRegion: '- Valitse alue -',
        mix: 'CO₂-seos',
        addressAndGps: 'Osoite & GPS',
        street: 'Katu',
        street2: 'Katu 2',
        postCode: 'Postinumero',
        city: 'Kaupunki',
        country: 'Maa',
        latitude: 'Leveysaste',
        longitude: 'Pituusaste',
        fetchGps: 'Hae GPS',
        fillStreetCityError:
          'Täytä katu ja kaupunki GPS-koordinaattien hakemiseksi.',
        requiredAddressFields: '{fields} on täytettävä ennen tallennusta.',
        searchCountry: 'Hae maa',
        floorNumber: 'Kerrosnumero',
        preferredCurrency: 'Oletusvaluutta',
        climateGoalPercentage: 'Ilmastotavoitteen prosenttiosuus',
        changeModel: 'Vaihda rakennuksen malli',
        defaultStartingFloor: 'Aloituskerros',
        startingViewHint:
          'Kierrä, siirrä ja zoomaa esikatselua valitaksesi näkymän, jolla rakennus avautuu.',
        matrikkelData: {
          title: 'Matrikkel-tiedot',
          error: 'Matrikkel-tietojen hakeminen epäonnistui',
          errorTitle: 'Virhe',
          matrikkelId: 'Matrikkel-ID',
          cadastralNumber: 'Kiinteistötunnus',
          propertyUnitNumber: 'Tilanumero',
          sectionNumber: 'Osanumero',
          unitNumber: 'Yksiköt',
          leaseholdNumber: 'Vuokraoikeuden numero',
          municipalityName: 'Kunnan nimi',
          municipalityNumber: 'Kuntanumero',
          success: 'Onnistui',
          successTitle: 'Onnistui',
          fetchMatrikkelData: 'Hae matrikkel-tiedot',
          buildingNumber: 'Rakennusnumero',
          errorMissing: 'Puuttuvat vaaditut osoitetiedot',
          errorTooMany: 'Liian monta osoitetta löytyi',
          errorNotFound: 'Osoitetta ei löytynyt',
          unitId: 'Yksikkötunnus',
          noUnitIdFound:
            'Yksikköä ei löytynyt tästä osoitteesta. Tarkista osoite seeiedom.no - sivustolta ja yritä uudelleen.',
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Osio',
          fetchedFromMatrikkel: 'Haettu matrikkelista',
          overrideButton: 'Ohita bruksenhet',
          overrideSectionButton: 'Ohita osio',
          addButton: 'Lisää bruksenhet',
          addSectionButton: 'Lisää osio',
          manualWarning:
            'Tarpeen vain, jos matrikkelitiedot puuttuvat tai ovat virheelliset.',
          buildingType: 'Rakennustyyppi',
        },
      },
      baseline: {
        title: 'Vertailuarvo',
        recalcButton: 'Laske vertailuarvo uudelleen',
        confirmRecalculate: 'Haluatko laskea vertailuarvon uudelleen?',
        success: 'Vertailuarvo laskettu',
        error: 'Vertailuarvon laskenta epäonnistui',
        subscriptions: {
          title: 'Elhub-tilaukset',
          loading: 'Ladataan tilauksia…',
          emptyState: 'Ei tilauksia. Lisää uusi alta.',
          actions: {
            unsubscribe: 'Peru tilaus',
            subscribe: 'Tilaa',
            delete: 'Poista',
            addPlaceholder: 'Syötä mittauspisteen ID',
            status: {
              waitingApproval: 'Odottaa asiakkaan hyväksyntää Elhubissa',
            },
            validation: {
              onlyDigits: 'ID saa sisältää vain numeroita',
              exactLength:
                'ID:n tulee olla täsmälleen 18 numeroa (esim. 707057500042153290)',
              startsWith: 'ID:n tulee alkaa 7070575000',
              unique: 'ID:n tulee olla yksilöllinen',
            },
            move: {
              selectTargetBuilding: '- Valitse kohderakennus -',
              moveSelected: 'Siirrä valitut',
              instructions:
                'Valitse siirrettävät tilaukset. Kesto n. 1 min / tilaus.',
              moveSubscriptions: 'Siirrä tilauksia',
            },
            feedback: {
              subscribeSuccess: 'Tilauksen pyyntö lähetetty',
              unsubscribeSuccess: 'Tilaus peruttu',
              deleteSuccess: 'Tilaus poistettu',
              subscribeError: 'Tilauksen pyyntö epäonnistui',
              unsubscribeError: 'Tilauksen peruutus epäonnistui',
              deleteError: 'Tilauksen poisto epäonnistui',
            },
          },
        },
      },
      report: { title: 'Raportti' },
    },
    model3d: {
      title: '3D-malli',
    },
    zoneEdit: {
      title: 'Alueen asetukset',
      form: {
        zoneName: 'Alueen nimi',
        floorNumber: 'Kerros',
        selectCategory: 'Valitse kategoria',
        isHeated: 'Lämmitetty alue',
        displayHint: 'Näin alue näkyy 3D-näkymässä.',
        cardSize: 'Kortin koko',
        zoneColor: 'Vyöhykkeen väri',
        devices: {
          availableDevices: 'Saatavilla olevat laitteet',
          zoneDevices: 'Alueen laitteet',
          noMatches: 'Yksikään laite ei vastaa hakua',
        },
        deleteButton: 'Poista alue',
        deleteZoneDescription: 'Poistaa alueen pysyvästi.',
        deleteZoneConfirm: 'Haluatko varmasti poistaa tämän alueen?',
        deleteError: 'Alueen poistaminen epäonnistui',
      },
    },
    technicalRoom: {
      titles: 'Tekninen tila',
      emptyState: 'Teknisiä tiloja ei löytynyt.',
      technicalRoomDescription: 'Teknisen tilan kuvaus',
      technicalRoomNamePlaceholder: 'Teknisen tilan nimi',
      technicalRoomDevices: 'Laitteet teknisessä tilassa',
      addDevice: 'Lisää laite',
      technicalRoomDevice: 'Teknisen tilan laite',
      removeDevice: 'Poista',
      searchPlaceholder: 'Hae teknistä tilaa',
      technicalRoomOverview: 'Teknisen tilan yleiskuva',
      technicalRoomValue: 'Arvo',
      technicalRoomSeen: 'Viimeksi nähty',
      addTechnicalRoom: 'Lisää tekninen tila',
      addDeviceButton: 'Lisää laite',
      removeDeviceButton: 'Poista laite',
      deviceType: 'Laitteen tyyppi',
      editorTitle: 'Tekniset tilat',
      selectRoom: 'Valitse tekninen tila',
      threeDModel: '3D-malli',
      replace: 'Vaihda',
      selectModel: 'Valitse 3D-malli',
      modelDefaultsGroup: 'Oletusmallit',
      noModel: 'Ei 3D-mallia tähän tilaan.',
      bind: 'Liitä',
      rebind: 'Liitä uudelleen',
      unbind: 'Irrota',
      boundTo: 'Liitetty kohteeseen',
      notBound: 'Ei liitetty',
      hide: 'Piilota 3D:ssä',
      show: 'Näytä 3D:ssä',
      size: 'Koko',
      remove: 'Poista tilasta',
      pickingHint: 'Napsauta mallia liittääksesi',
      pickingCardHint:
        'Napsauta mallin osaa tai taustaa sijoittaaksesi kortin vapaasti',
      searchDevices: 'Hae laitteita…',
      noDevicesAvailable: 'Ei laitteita saatavilla',
      noMatches: 'Ei osumia',
      unnamedDevice: 'Nimeämätön laite',
      couldNotAddDevice: 'Laitetta ei voitu lisätä',
      noReadings24h: 'Ei mittauksia viimeisen 24 tunnin aikana',
      dragToReposition: 'Vedä siirtääksesi',
      hideGraph: 'Piilota kuvaaja',
      showGraph: 'Näytä kuvaaja',
      lockedHint: 'Avaa näkymän lukitus siirtääksesi laitteita',
      clickToEdit: 'Muokkaa napsauttamalla',
      noDescription: 'Ei kuvausta',
      noTitle: 'Ei otsikkoa',
      showCardTitle: 'Kortin otsikko',
      showDeviceName: 'Laitteen nimi',
      cardVisualization: 'Kortin visualisointi',
      modelAnimation: 'Mallin animaatio',
      showLine: 'Yhdysviiva',
      lineColor: 'Viivan väri',
      resetColor: 'Palauta väri',
      darkTheme: 'Tumma teema',
      showUnit: 'Yksikkö',
      trendLine: 'Trendiviiva',
      trendBars: 'Trendipalkit',
      showUpdated: 'Viimeksi päivitetty',
      visualizationRules: 'Visualisointisäännöt',
      ruleDataKey: 'Tietoavain',
      ruleValue: 'Arvo',
      triggers: 'Liipaisimet',
      addTrigger: 'Lisää liipaisin',
      ruleOff: 'Pois',
      ruleSlow: 'Hidas',
      ruleFast: 'Nopea',
      ruleNoEffect: 'Ei vaikutusta',
      ruleNoColor: 'Ei väriä',
      ruleReverse: 'Käännä suunta',
      particleFlow: 'Hiukkasvirtaus',
      drawFlow: 'Piirrä virtaus',
      flowHint: 'Lisää pisteitä napsauttamalla mallia.',
      flowFollowsHint:
        'Hiukkaset seuraavat mallin animaation liipaisimia. Kun animaatio on pois päältä, hiukkaset pysähtyvät.',
      flowColorHint:
        'Napsauta virtauksen pistettä mallissa vaihtaaksesi värin siitä eteenpäin.',
      flowColorFromPoint: 'Väri valitusta pisteestä',
      flowFollows: 'Seuraa animaatiota',
      particles: 'Hiukkaset',
      ruleDataKeyRequired: 'Valitse tietoavain visualisointisäännölle',
      newTechnicalRoom: 'Uusi tekninen tila',
      roomNamePlaceholder: 'esim. Ilmanvaihto, Lämmönjakohuone, Lämpöpumppu',
      selectBuilding: 'Valitse rakennus',
      nameRequired: 'Nimi vaaditaan',
      buildingRequired: 'Rakennus vaaditaan',
      couldNotCreateRoom: 'Tilan luonti epäonnistui',
      creating: 'Luodaan',
      loadError: 'Teknisen tilan lataus epäonnistui',
      textPlaceholder: 'Kirjoita teksti…',
      noText: 'Ei tekstiä',
      linkToRoom: 'Siirry huoneeseen',
      noLink: 'Ei linkkiä',
      linkHint:
        'Lukitussa näkymässä mallin tai kortin napsautus avaa tämän huoneen.',
      confirmRemoveAnnotation:
        'Haluatko varmasti poistaa tämän tekstin huoneesta?',
      dragToReorder: 'Vedä järjestääksesi',
      drawFrame: 'Piirrä kehys',
      redrawFrame: 'Piirrä kehys uudelleen',
      frameDrawHint: 'Napsauta kahta kulmaa piirustuksessa',
      noFrame: 'Kehystä ei piirretty',
      frameDrawn: 'Kehys piirretty',
      confirmRemoveFrame: 'Haluatko varmasti poistaa tämän kehyksen huoneesta?',
      confirmRemoveLink: 'Haluatko varmasti poistaa tämän linkin huoneesta?',
      annotationsTab: 'Linkit ja teksti',
      noAnnotations: 'Tässä huoneessa ei ole linkkejä tai tekstiä.',
      placeText: 'Sijoita',
      replaceText: 'Sijoita uudelleen',
      placed: 'Sijoitettu',
      placeTextHint: 'Napsauta piirustusta kohdasta, johon teksti tulee',
      placeInfoHint: 'Napsauta piirustusta kohdasta, johon kupla tulee',
      confirmRemoveInfo:
        'Haluatko varmasti poistaa tämän infokuplan huoneesta?',
      ruleAngle: 'Kulma (astetta)',
      infoPanel: 'Hälytykset ja käyttökalenteri',
      alarmsTab: 'Hälytykset',
      calendarsTab: 'Käyttökalenteri',
      noAlarmSystems: 'Tähän huoneeseen ei ole liitetty hälytysjärjestelmiä.',
      noCalendars: 'Tähän huoneeseen ei ole liitetty käyttökalentereita.',
      systemAlarm: 'Järjestelmähälytys',
      openInSettings: 'Avaa asetuksissa',
      confirmRemoveDevice: 'Haluatko varmasti poistaa tämän laitteen tilasta?',
      attributes: 'Attribuutit',
      selectAttribute: 'Valitse attribuutti',
      mappedGroup: 'Määritetyt attribuutit',
      payloadGroup: 'Raakadata',
      mappedNoneText: 'Ei saatavilla,',
      assignHere: 'määritä tästä',
      confirmDeleteRoom: 'Haluatko varmasti poistaa kohteen {name}?',
      roomDeleted: 'Tekninen tila poistettu',
      renameRoom: 'Nimeä tekninen tila uudelleen',
      noTechnicalRoomsForType: 'Tämän tyyppisiä teknisiä tiloja ei löytynyt',
      noDevices: 'Teknisessä tilassa ei ole laitteita.',
      technicalRoomTypeLabel: 'Teknisen tilan tyyppi',
      technicalRoomTypes: {
        type: 'Valitse tyyppi',
        hvac: 'LVI',
        technical: 'Tekninen tila',
        electrical: 'Sähkö',
        plumbing: 'Putkisto',
        other: 'Muu',
      },
      message: {
        success: 'Tekninen tila luotu onnistuneesti',
        updateSuccess: 'Tekninen tila päivitetty onnistuneesti',
        deleteSuccess: 'Tekninen tila poistettu onnistuneesti',
        error: 'Tapahtui virhe käsiteltäessä pyyntöäsi',
        deleteConfirm: 'Haluatko varmasti poistaa tämän teknisen tilan?',
      },
    },
  },
  threeD: {
    lockView: 'Lukitse näkymä',
    unlockView: 'Avaa näkymän lukitus',
  },

  buildings3D: {
    header: {
      buildingTab: 'Rakennus',
      technicalTab: 'Tekninen',
    },
    footer: {
      home: 'Koti',
      measure: 'Mittaa',
      stopMeasure: 'Lopeta mittaus',
      explode: 'Räjäytä',
      screenshot: 'Kuvakaappaus',
      lock: 'Lukitse',
      unlock: 'Poista lukitus',
    },
    climate: {
      buildingClimate: 'Sisäilmasto',
      levelsTitle: 'Osiot',
      startLabel: 'Alku',
      endLabel: 'Loppu',
      apply: 'Käytä',
      avgTemperature: 'Keskilämpötila',
      avgHumidity: 'Keskimääräinen ilmankosteus',
      avgCo2: 'Keskimääräinen CO₂',
      floor: 'Kerros',
      wholeBuilding: 'Koko rakennus',
      noTrendData: 'Ei dataa',
      fetchData: 'Hae data',
      startMustBeBeforeEnd: 'Alun on oltava ennen loppua.',
      groundFloor: 'Katukerros',
      weekdaysShort: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
    },
    status: {
      good: 'Hyvä',
      tooLow: 'Liian matala',
      tooHigh: 'Liian korkea',
      warning: 'Varoitus',
      poor: 'Huono',
    },
    warnings: {
      title: 'Varoitukset',
      highCo2: 'Korkea CO₂',
      highTemp: 'Korkea lämpötila',
      lowTemp: 'Matala lämpötila',
    },
    alarmLog: {
      title: 'Hälytysloki',
      last24h: 'Viimeiset 24 tuntia',
      last7d: 'Viimeiset 7 päivää',
      last30d: 'Viimeiset 30 päivää',
      custom: 'Mukautettu',
      zone: 'Vyöhyke',
      activeNow: 'Aktiiviset nyt',
      today: 'Tänään',
      yesterday: 'Eilen',
      earlier: 'Aiemmin',
      empty: 'Ei hälytyksiä tällä aikavälillä',
      loadError: 'Hälytyslokia ei voitu ladata.',
      unknownZone: 'Tuntematon vyöhyke',
    },
    deviceLayer: {
      moveDevices: 'Siirrä malleja',
      moveHint: 'Siirrä vetämällä · ⇧ kierrä · ⌘ korkeus',
      moveThisDevice: 'Siirrä tätä laitetta',
      doneMoving: 'Siirto valmis',
      changeModel: 'Vaihda mallia',
      showDataBox: 'Näytä tietolaatikko',
      hideDataBox: 'Piilota tietolaatikko',
      modelSize: 'Mallin koko',
      dataSize: 'Tietojen koko',
      hideZones: 'Piilota vyöhykkeet',
      showZones: 'Näytä vyöhykkeet',
      hideModels: 'Piilota mallit',
      showModels: 'Näytä mallit',
      hideModel: 'Piilota malli',
      showModel: 'Näytä malli',
      suggested: 'Ehdotettu',
      noModelsInCategory: 'Ei malleja tässä kategoriassa vielä',
      controllers: 'Ohjaimet',
      models: {
        radiatorGlb: 'Lämpöpatteri',
        panelOvenGlb: 'Paneelilämmitin',
        heatpumpGlb: 'Lämpöpumppu',
        indoorClimateGlb: 'Sisäilma',
        icmSensorGlb: 'ICM anturi',
        climateHubGlb: 'Ilmastohubi',
        ventilationOutletGlb: 'Ilmanvaihtoventtiili',
        ventilationGrillGlb: 'Ilmanvaihtosäleikkö',
      },
    },
    zoneControls: {
      leaveFloor: 'Poistu',
      drawZone: 'Kaksoisnapsauta lopettaaksesi',
      clearZones: 'Tyhjennä alueet',
      clickFloorToIsolate: 'Klikkaa kerrosta eristääksesi',
      select: 'Valitse',
      rectangle: 'Suorakulmio',
      circle: 'Ympyrä',
      polygon: 'Monikulmio',
      zoneNameLabel: 'Vyöhykkeen nimi',
      heightLabel: 'Korkeus',
      editVertexHint: 'Muokkaa vetämällä pisteitä, lisää kaksoisnapsauttamalla',
      unnamedZone: 'Nimetön vyöhyke',
      zoneNameRequired: 'Vyöhykkeen nimi vaaditaan',
      zonesMissingData: 'Vyöhykkeiltä puuttuu 3D data',
      zonesMissingDataTitle: 'Vyöhykkeiltä puuttuu 3D mallidata:',
      floorLabel: 'Kerros',
      zoneCreated: 'Vyöhyke luotu',
      zoneUpdated: 'Vyöhyke päivitetty',
      zoneDeleted: 'Vyöhyke poistettu',
      failedToCreateZone: 'Vyöhykkeen luonti epäonnistui',
      failedToUpdateZone: 'Vyöhykkeen päivitys epäonnistui',
      failedToDeleteZone: 'Vyöhykkeen poisto epäonnistui',
      confirmDeleteZoneTitle: 'Poista vyöhyke?',
      confirmDeleteZoneMessage:
        'Haluatko varmasti poistaa tämän vyöhykkeen? Tätä ei voi peruuttaa.',
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Laitehälytys päivitetty onnistuneesti',
    createdSuccess: 'Laitehälytys luotu onnistuneesti',
    deletedSuccess: 'Laitehälytys poistettu onnistuneesti',

    editTitle: 'Muokkaa laitehälytystä',
    createTitle: 'Luo laitehälytys',
    title: 'Laitehälytykset',
    manageAlarmsForDevice: 'Hallitse hälytyksiä laitteelle {device}',
    recipients: 'Vastaanottajaluettelo',

    alarmDetails: 'Hälytyksen tiedot',
    deviceSelection: 'Laitteen valinta',
    alarmConditions: 'Hälytysehdot',
    condition: 'Ehto',
    conditions: 'Ehdot',
    noConditions: 'Ehtoja ei ole vielä lisätty.',
    noConditionsSaveError: 'Vähintään yksi ehto vaaditaan',

    name: 'Nimi',
    description: 'Kuvaus',
    alarmSystem: 'Hälytysjärjestelmä',
    selectDevice: 'Valitse laite',
    dataKey: 'Data-avain',
    selectKey: 'Valitse avain',
    level: 'Taso',
    operator: 'Operaattori',
    value: 'Arvo',
    duration: 'Kesto (min)',
    message: 'Viesti',
    active: 'Aktiivinen',

    greaterThan: 'Suurempi kuin',
    lessThan: 'Pienempi kuin',
    equal: 'Yhtä suuri',
    notEqual: 'Eri suuri',
    missing: 'Puuttuu',
    unchanged: 'Muuttumaton',

    addTrigger: 'Lisää laukaisin',
    addCondition: 'Lisää ehto',
    triggers: 'Laukaisimet',

    standardDevices: 'Vakiolaitteet',
    eosDevices: 'EOS-laitteet',
    noDataKeys: 'Ei data-avaimia saatavilla tälle laitteelle.',

    noAlarmSystems: 'Ei hälytysjärjestelmiä saatavilla.',
    pleaseCreateFirst: 'Luo ensin yksi',
    selectDeviceFirst: 'Valitse ensin laite määrittääksesi hälytysehdot.',
    messagePlaceholder: 'Näytettävä hälytysviesti...',
    confirmDelete: 'Haluatko varmasti poistaa tämän laitehälytyksen?',
    list: {
      new: 'Uusi',
      search: 'Hae...',
      empty: 'Laitehälytyksiä ei löytynyt',
    },
    deleteAlarmTitle: 'Poista hälytys',
    deleteAlarmDescription: 'Tätä toimintoa ei voi perua.',
  },

  settings: {
    /* ----------------------------- NAV AREAS ---------------------------- */
    areas: {
      home: 'Etusivu',
      vendor: 'Yleiset',
      devices: 'Laitteet',
      eos_devices: 'EOS-laitteet',
      categories: 'Kategoriat',
      users: 'Käyttäjät',
      themes: 'Teemat',
      integrationOverview: 'API-integraatiot',
      fileCloud: 'Tiedostopilvi',
      energyPrices: 'Energiahinnat',
      alarms: 'Hälytykset',
      alarmSystemDescription:
        'Hallitse ja mukauta hälytysjärjestelmiä räätälöidyillä ilmoituksilla ja sydämenlyöntiseurannalla pysyäksesi ajan tasalla kriittisistä tapahtumista ja varmistaaksesi oikea-aikaiset toimenpiteet.',
      baseline: 'Vertailulinja',
      technicalRoomOverview: 'Tekninen tila',
      aspaSetup: 'ASPA asetukset',
      controlStrategy: 'Ohjausstrategia',
      operatingCalendar: 'Käyttökalenterit',
      setpoint: 'Asetusarvot',
    },
    home: {
      title: 'Yrityksen hallintapaneeli',
      tagline:
        'Hallinnoi yrityksesi asetuksia, käyttäjiä, laitteita ja teemoja yhdessä paikassa',
    },
    dashboardItems: {
      themes: {
        title: 'Teemat',
        description: 'Luo ja hallinnoi sovelluksesi väriteemoja',
        linkText: 'Näytä teemat',
      },
      users: {
        title: 'Käyttäjät',
        description: 'Hallinnoi käyttäjien tilejä ja oikeuksia',
        linkText: 'Näytä käyttäjät',
      },
      eosDevices: {
        title: 'EOS-laitteet',
        description: 'Seuraa ja hallinnoi energiaseurantakennoja',
        linkText: 'Näytä EOS-laitteet',
      },
      settings: {
        title: 'Asetukset',
        description: 'Määritä sovelluksen yleiset asetukset',
        linkText: 'Näytä asetukset',
      },
      devices: {
        title: 'Laitteet',
        description: 'Määritä ja valvo yhdistettyjä laitteita',
        linkText: 'Näytä laitteet',
      },
      fileCloud: {
        title: 'Tiedostopilvi',
        description:
          'Tallenna, järjestä ja jaa tiedostoja koko organisaatiossa',
        linkText: 'Näytä tiedostot',
      },
      integration: {
        title: 'API-integraatiot',
        description: 'Määritä ja hallinnoi API-yhteyksiä ja integraatioita',
        linkText: 'Näytä integraatiot',
      },
      categories: {
        title: 'Kategoriat',
        description: 'Luo ja hallinnoi laitekategorioita',
        linkText: 'Näytä kategoriat',
      },
    },
    aspaSetup: {
      list: {
        header: 'ASPA asetukset',
        addButton: 'Lisää ASPA asetus',
        emptyState: 'ASPA asetuksia ei löytynyt.',
        searchPlaceholder: 'Hae...',
      },
      edit: {
        name: 'ASPA asetuksen nimi',
        units: 'Yksiköt',
        addUnit: 'Lisää yksikkö',
        unitName: 'Yksikön nimi',
        setpoints: 'Asetusarvot',
        zones: 'Vyöhykkeet',
        removeUnit: 'Poista yksikkö',
        copyMondayToWeekdays: 'Kopioi maanantai arkipäiviin',
        copyMondayToAllDays: 'Kopioi maanantai kaikkiin päiviin',
      },
      feedback: {
        deleteSuccess: 'ASPA asetus poistettu onnistuneesti',
        deleteError: 'Virhe poistettaessa ASPA asetusta',
        updateSuccess: 'ASPA asetus päivitetty onnistuneesti',
        updateError: 'Virhe päivitettäessä ASPA asetusta',
        createSuccess: 'ASPA asetus luotu onnistuneesti',
        createError: 'Virhe luotaessa ASPA asetusta',
        saveError: 'Virhe tallennettaessa ASPA asetusta',
      },
    },

    energyPrices: {
      list: {
        add: 'Lisää energiahinta',
        header: 'Energiahintojen asetukset',
        emptyState: 'Energiahintojen asetuksia ei löytynyt.',
        searchPlaceholder: 'Hae energiahintojen asetuksia...',
      },

      name: 'Nimi',
      notes: 'Muistiinpanot',
      building: 'Rakennus',
      selectBuilding: 'Valitse rakennus',
      validFrom: 'Voimassa alkaen',
      validTo: 'Voimassa asti',
      ongoing: 'Toistaiseksi',
      notSpecified: 'Ei määritelty',

      electricityDetails: 'Sähkön tiedot',
      priceModel: 'Hinnoittelumalli',
      fixed: 'Kiinteä hinta',
      spotMarkup: 'Spot + lisämaksu',
      fixedPricePerKWh: 'Kiinteä hinta per kWh',
      spotMarkupPerKWh: 'Lisämaksu per kWh',

      supplierMonthlyFee: 'Toimittajan kuukausimaksu',
      co2Emissions: 'CO₂-päästöt (gCO₂/kWh)',

      gridTariffs: 'Verkkomaksut',
      gridTariff: 'Verkkomaksu',
      fixedMonthly: 'Kiinteä kuukausimaksu',
      energyPerKWh: 'Energia per kWh',
      demandPerKWMonthly: 'Tehomaksu per kW kuukaudessa',
      consumptionTaxPerKWh: 'Kulutusvero per kWh',

      energySources: 'Energialähteet',
      addEnergySources: 'Lisää energialähteitä',
      energySource: 'Energialähteen tiedot',
      sourceName: 'Lähteen nimi',
      electricity: 'Toimitettu sähkö',
      electricityPrice: 'Sähkön hinta',
      electricityProduced: 'Tuotettu sähkö',
      electricityExported: 'Viety sähkö',

      districtHeating: 'Kaukolämpö',
      districtHeatingSource: 'Kaukolämmön energialähde',
      districtHeatingPrice: 'Kaukolämmön hinta',
      districtHeatingEnergyPrice: 'Energiahinta (kr/kWh)',
      districtHeatingDemandPerKWMonthly: 'Suurin mitattu teho (kr/kW/kk)',

      fuelSources: 'Polttoainelähteet',
      fuelSource: 'Polttoainelähteen tiedot',
      fuelType: 'Energialähde',

      propane: 'Propaani',
      fuelOilDiesel: 'Polttoöljy / Diesel',
      lng: 'Maakaasu (LNG)',
      kerosene: 'Kerosiini',
      pelletsBricks: 'Pellettit / Briketit',
      biodiesel: 'Biodiesel',
      biogas: 'Biokaasu',
      other: 'Muu',

      consumptionUnit: 'Kulutusyksikkö',
      kg: 'kg',
      liter: 'litra',
      unitPrice: 'Yksikköhinta',
      consumption: 'Kulutus',
      conversionFactorToKWh: 'Muuntokerroin kWh:ksi',

      periodLabel: 'Jakso',
      periodLabelPlural: 'Jaksot',
      periodName: 'Jakson nimi',
      addPeriod: 'Lisää jakso',
      removePeriod: 'Poista jakso',
      removePeriodConfirmation: 'Haluatko varmasti poistaa tämän jakson?',
      noPeriodsDefined: 'Ei jaksoja.',
      overlappingPeriodsError:
        'Jaksot "{p1}" ja "{p2}" ovat päällekkäisiä.\n\n' +
        'Et voi määrittää kahta samanaikaisesti voimassa olevaa jaksoa (samat kuukaudet ja päällekkäiset ajat). ' +
        'Muokkaa kuukausia tai aktiivisia aikoja ennen tallentamista.',
      confirmRemovePeriod: 'Haluatko varmasti poistaa tämän jakson?',
      mixedMonthsError:
        'Et voi yhdistää tiettyjä kuukausia ja "kaikkia kuukausia" (tyhjät kuukaudet) eri jaksojen välillä.\n\n' +
        'Näiden jaksojen on valittava kuukaudet: {periods}\n\n' +
        'Vinkki: valitse kuukaudet kaikille jaksoille tai jätä kuukaudet tyhjiksi kaikille.',

      generalInformation: 'Yleiset tiedot',
      activeMonths: 'Aktiiviset kuukaudet (kaikki jos tyhjä)',
      activeBetween: 'Aktiivinen aika (koko päivä jos tyhjä)',
      chosenMonths: 'Aktiiviset kuukaudet',
      activeHours: 'Aktiiviset ajat',
      allYear: 'Koko vuoden',
      allDay: 'Koko päivän',

      co2Source: 'Kaukolämmön energiatyyppi',
      co2Array: [
        'Sähkö',
        'Jäte',
        'Kevyt polttoöljy',
        'Raskas polttoöljy',
        'Nestekaasu (LPG)',
        'Maakaasu (LNG)',
        'Ensisijainen puubiomassa',
        'Toissijainen puubiomassa',
        'RT-hake',
        'Pellettit, briketit ja jauhe',
        'Bioöljy',
        'Lämpöpumppu',
      ],

      fixedFees: 'Kiinteät maksut',
      substationFee: 'Alajakokeskuksen maksu (kk)',
      reactiveEffect: 'Loistehomaksu',
      connectedDevices: 'Liitetyt laitteet',
      noConnectedDevices: 'Ei liitettyjä laitteita',
      deletedDevice: 'Poistettu',
      removeSource: 'Poista lähde',
      noLinkedDevices: 'Ei linkitettyjä laitteita',
      linked: 'Linkitetyt laitteet',
      unlinkDeviceMessage: 'Oletko varma, että haluat poistaa tämän laitteen?',
      addAdditionalTimer: 'Lisää uusi aikaväli',
      startTime: 'Aloitusaika ',
      endTime: 'Lopetusaika ',
      timeRangeInvalid: 'Loppuajan on oltava aloitusajan jälkeen',
      timeRangesOverlap: 'Aikavälit eivät saa olla päällekkäisiä',
      timeRangeEqual: 'Aloitus- ja lopetusaika eivät voi olla samat',

      linkSourceTitle: 'Linkitä lähde EOS-laitteeseen',
      linkSource: 'Linkitä lähde EOS-laitteisiin',
      linkSourceDescription:
        'Valitse EOS-laitteet, jotka on linkitetty tähän energialähteeseen.',

      removeElectricitySourceConfirmation:
        'Haluatko varmasti poistaa sähkölähteen ',
      removeDistrictHeatingSourceConfirmation:
        'Haluatko varmasti poistaa kaukolämpölähteen ',
      removeFuelSourceConfirmation:
        'Haluatko varmasti poistaa polttoainelähteen ',
    },

    setpoint: {
      title: 'Asetusarvot',
      backToList: 'Kaikki asetusarvot',
      description:
        'Lämpötilan, kosteuden ja CO₂:n raja-arvot rakennuksittain ja vyöhykkeittäin.',
      searchPlaceholder: 'Hae asetusarvoja …',
      emptyState: 'Ei vielä asetusarvoja.',
      addButton: 'Uusi asetusarvo',
      loadError: 'Asetusarvoja ei voitu hakea.',
      zonesLoadError: 'Vyöhykkeitä ei voitu hakea.',
      saveError: 'Asetusarvoa ei voitu tallentaa.',
      deleteError: 'Asetusarvoa ei voitu poistaa.',
      requiredError: 'Nämä kentät ovat pakollisia:',
      deleteConfirmTitle: 'Poista asetusarvo',
      deleteConfirmMessage:
        'Haluatko varmasti poistaa tämän asetusarvon? Tätä ei voi kumota.',
      editTitle: 'Muokkaa asetusarvoa',
      newTitle: 'Uusi asetusarvo',
      editDescription: 'Raja-arvot koskevat valitsemiasi vyöhykkeitä.',
      saveButton: 'Tallenna asetusarvo',
      openSetpoint: 'Avaa asetusarvo',
      buildingSection: 'Rakennus',
      building: 'Rakennus',
      name: 'Nimi',
      namePlaceholder: 'Esim. Toimisto vakio',
      zonesSection: 'Vyöhykkeet',
      selectAll: 'Valitse kaikki',
      clearAll: 'Tyhjennä kaikki',
      noZones: 'Valitse rakennus nähdäksesi sen vyöhykkeet.',
      allZonesTaken:
        'Kaikilla tämän rakennuksen vyöhykkeillä on jo asetusarvo.',
      zonesTakenError:
        'Yksi tai useampi vyöhyke kuuluu jo toiseen asetusarvoon.',
      noZonesSelected: 'Ei valittuja vyöhykkeitä',
      floor: 'Kerros',
      noFloor: '—',
      limitsSection: 'Raja-arvot',
      columns: {
        name: 'Nimi',
        building: 'Rakennus',
        zones: 'Vyöhykkeet',
        inOperation: 'Käytössä',
        outsideOperation: 'Käytön ulkopuolella',
        interval: 'Tarkistusväli',
      },
    },
    operatingCalendar: {
      backToList: 'Kaikki käyttökalenterit',
      title: 'Käyttökalenterit',
      description:
        'Normaali käyttöaika rakennusta ja vyöhykettä kohden, päällä poikkeuskäyttö.',
      searchPlaceholder: 'Hae käyttökalentereita …',
      emptyState: 'Ei vielä käyttökalentereita.',
      addButton: 'Uusi käyttökalenteri',
      running: 'Jatkuva, ei päättymispäivää',
      openCalendar: 'Avaa kalenteri',
      zonesLoadError: 'Vyöhykkeiden haku epäonnistui.',
      loadError: 'Käyttökalenterien haku epäonnistui.',
      saveError: 'Käyttökalenterin tallennus epäonnistui.',
      deleteError: 'Käyttökalenterin poisto epäonnistui.',
      requiredError: 'Nämä kentät ovat pakollisia:',
      deleteConfirmTitle: 'Poista käyttökalenteri',
      deleteConfirmMessage:
        'Haluatko varmasti poistaa tämän käyttökalenterin? Toimintoa ei voi perua.',
      editTitle: 'Määritä normaalikäyttö',
      editDescription:
        'Kiinteä viikoittainen käyttöaika valituille vyöhykkeille.',
      saveButton: 'Tallenna normaalikäyttö',
      buildingSection: 'Rakennus',
      building: 'Rakennus',
      zonesSection: 'Vyöhykkeet',
      selectAll: 'Valitse kaikki',
      clearAll: 'Tyhjennä',
      noZonesSelected: 'Ei valittuja vyöhykkeitä',
      zonesTakenError:
        'Yksi tai useampi vyöhyke kuuluu jo toiseen käyttökalenteriin.',
      allZonesTaken:
        'Kaikki tämän rakennuksen vyöhykkeet kuuluvat jo käyttökalenteriin.',
      noZones: 'Valitse rakennus nähdäksesi vyöhykkeet.',
      floor: 'Kerros',
      noFloor: 'Ei kerrosta',
      validitySection: 'Nimi ja voimassaolo',
      name: 'Nimi',
      validFrom: 'Voimassa alkaen',
      validTo: 'Voimassa asti',
      weekPlanSection: 'Viikkosuunnitelma',
      copyMonday: 'Kopioi maanantai kaikille arkipäiville',
      noOperation: 'Ei käyttöä',
      weeklyTotal: 'Yhteensä viikossa',
      from: 'Alkaen',
      to: 'Asti',
      calendarTitle: 'Käyttökalenteri',
      week: 'Viikko',
      previousWeek: 'Edellinen viikko',
      nextWeek: 'Seuraava viikko',
      today: 'Tänään',
      editNormal: 'Normaalikäyttö',
      addOverride: 'Lisää poikkeuskäyttö',
      thisWeek: 'Tällä viikolla',
      operatingHours: 'Käyttötunnit',
      extraordinaryDays: 'Poikkeuspäivät',
      upcomingOverrides: 'Tulevat poikkeuskäytöt',
      noOverrides: 'Ei suunniteltua.',
      fixedOperation: 'Kiinteä käyttö',
      publicHoliday: 'Pyhäpäivä',
      extraordinary: 'Poikkeuskäyttö',
      closed: 'Suljettu',
      opensAt: 'Avautuu',
      closesAt: 'Sulkeutuu',
      inOperation: 'Käytössä',
      outOfOperation: 'Pois käytöstä',
      allDay: 'Koko päivä',
      reason: 'Syy',
      overrideSaveError: 'Poikkeuskäytön tallennus epäonnistui.',
      overrideDeleteError: 'Poisto epäonnistui.',
      columns: {
        name: 'Nimi',
        building: 'Rakennus',
        zones: 'Vyöhykkeet',
        validity: 'Voimassaolo',
        hoursPerWeek: 'Tuntia/vko',
      },
      weekdays: {
        mon: 'Ma',
        tue: 'Ti',
        wed: 'Ke',
        thu: 'To',
        fri: 'Pe',
        sat: 'La',
        sun: 'Su',
      },
    },
    controlStrategy: {
      list: {
        header: 'Ohjausstrategiat',
        addButton: 'Lisää ohjausstrategia',
        emptyState: 'Ohjausstrategioita ei löydy.',
        searchPlaceholder: 'Hae rakennuksella...',
      },
      feedback: {
        saveSuccess: 'Ohjausstrategia tallennettu',
        saveError: 'Virhe ohjausstrategian tallentamisessa',
        buildingRequired: 'Rakennus on pakollinen',
        bothHoursRequired: 'Sekä alku- että lopetusaika on täytettävä',
        startBeforeEnd: 'Alkuajan on oltava ennen lopetusaikaa',
        deleteSuccess: 'Ohjausstrategia poistettu',
        deleteError: 'Virhe ohjausstrategian poistamisessa',
        confirmDeleteTitle: 'Poista ohjausstrategia',
        confirmDeleteMessage:
          'Haluatko varmasti poistaa tämän ohjausstrategian? Tätä ei voi peruuttaa.',
      },
      schedule: 'Käyttöaika',
      timezone: 'Aikavyöhyke',
      startHour: 'Käyttöaika alku',
      endHour: 'Käyttöaika loppu',
      actions: 'Toiminnot',
      coolingLevel: 'Jäähdytystaso',
      heatingLevel: 'Lämmitystaso',
      businessHoursControl: 'Ohjaus aukioloaikana',
      afterHoursControl: 'Ohjaus aukioloajan ulkopuolella',
      controlOutsideBusinessHours: 'Ohjaa aukioloajan ulkopuolella',
      tempMin: 'Lämpötila min (°C)',
      tempMax: 'Lämpötila maks (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ maks (ppm)',
      actionLabels: {
        cool: 'Jäähdytys',
        heat: 'Lämmitys',
        preCool: 'Esijäähdytys',
        preHeat: 'Esilämmitys',
        ventilate: 'Tuuletus',
        dehumidify: 'Kosteudenpoisto',
      },
      closed: 'Suljettu',
      afterHoursActions: 'Toiminnot käyttöajan ulkopuolella',
    },

    baseline: {
      updated: 'Päivitetty',
      title: 'Vertailutaso',
      searchPlaceholder: 'Hae vertailutasoa...',
      addButtonLabel: 'Luo uusi vertailutaso',
      confirmDeleteTitle: 'Poista vertailutaso',
      confirmDeleteMessage: 'Haluatko varmasti poistaa tämän vertailutason?',
      noBaselines: 'Vertailutasoja ei löytynyt. Luo uusi vertailutaso.',
      createNewBaselineConfirm:
        'Luodaanko uusi vertailutaso? Tämä korvaa nykyisen.',
      editBaseline: 'Muokkaa vertailutasoa kohteelle',
      calculateBaseline: 'Laske vertailutaso',
      baselineChart: 'Vertailutasokaavio',
      monthsCovered: 'Kuukaudet mukana',
      excludeMonths: 'Poissulje kuukaudet',
      pendingChanges:
        'Tallentamattomia muutoksia. Napsauta Tallenna päivittääksesi vertailutason.',
      clickMonthsToExclude: `Napsauta kuukausia sulkeaksesi ne pois vertailutasosta. Oranssit kuukaudet poikkeavat vertailutasosta 20 % tai enemmän.`,
      year: 'Vuosi',
      month: 'Kuukausi',
      energyType: 'Energian tyyppi',
      monthlySummary: 'Kuukausiyhteenveto',
      weeklySummary: 'Viikkoyhteenveto',
      week: 'Viikko',
      summary: 'Yhteenveto',
      excluded: 'Poissuljettu vertailutasosta',
      energyTypes: {
        electricity: 'Sähkö',
        districtHeating: 'Kaukolämpö',
        fuel: 'Polttoaine',
      },
      overBaseline: 'Ylittää vertailutason',
      underBaseline: 'Alittaa vertailutason',
      included: 'Sisältyy vertailutasoon',
      activeLabel: 'Aktiivinen',
      inactiveLabel: 'Ei aktiivinen',
      createdAt: 'Luotu',
      lockTooltip: {
        locked: 'Lukittu — avaa salliaksesi muutokset',
        unlocked: 'Lukitse estääksesi muutokset',
      },
      description: 'Luo ja määritä vertailutasoja',
      backButtonLabel: 'Takaisin vertailutasoihin',
    },

    topics: {
      addButton: '+ Lisää aihe',
      eosName: 'EOS-nimi',
      sensorTag: 'Sensor-tagi',
      sensorTagRequired: 'Sensor-tagi vaaditaan',
      sensorTagTooShort: 'Sensor-tagin on oltava vähintään 3 merkkiä',
      assignedTo: 'Käytössä laitteella',
      aggregator: {
        title: 'Aggregaattori',
        sum: 'Summa',
        average: 'Keskiarvo',
        max: 'Maksimi',
        min: 'Minimi',
        cumulative: 'Kumulatiivinen',
        differential: 'Differenssi',
        last: 'Viimeisin',
      },
      scale: 'Skaala',
      decimals: 'Desimaaleja',
      units: 'Yksiköt',
      removeButton: 'Poista',
      deleteTopic: 'Poista aihe',
      confirmDelete: 'Haluatko varmasti poistaa tämän aiheen?',
    },
    devices: {
      installNetmoreButton: 'Asenna Netmore-sovellus',
      gatewayInstaller: 'Asenna Gateway-sovellus laitteellesi',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Asenna ChirpStack-laite',
      serialNumber: 'Sarjanumero',
      bulkSerialsLabel: 'Sarjanumerot (pilkulla tai uudelle riville)',
      ui: {
        singleModeTitle: 'Yksittäinen laite',
        bulkModeTitle: 'Massa-asennus',
        bulkNameHintLine1: 'Nimi on tyhjä -> sarjanumeroita käytetään niminä',
        bulkNameHintLine2:
          'Nimi on asetettu -> kaikki laitteet käyttävät samaa nimeä',
      },
      visualToggle: {
        visualToggleDevice: 'Visual Toggle -laite',
        visualToggleBuilding: 'Rakennus',
        visualToggleDelimiter: 'Erotin',
        visualToggleDataKey: 'Datan avain',
        visualToggleProperty: 'Ominaisuus',
        visualTogglePropertyId: 'Ominaisuuden ID',
        visualToggleValue: 'Arvo',
        visualToggleColor: 'Väri',
        visualToggleTriggers: 'Laukaisimet',
        visualToggleAddTrigger: 'Lisää laukaisin',
        visualToggleRemove: 'Poista laukaisin',
        visualToggleSelectBuilding: 'Valitse rakennus',
        visualToggleSelectValue: 'Valitse arvo',
        visualToggleDev: 'Laite',
        visualToggleManagement: 'Visual Toggle -hallinta',
        visualToggleAdd: 'Lisää Visual Toggle -laite',
        visualToggleGlobalModels: 'Globaalit 3D-mallit',
        visualToggleDelete: 'Poista Visual Toggle -laite',
        visualToggleNoDevices: 'Visual Toggle -laitteita ei löytynyt.',
        visualToggleSearchPlaceholder: 'Hae Visual Toggle -laitteita...',
        visualtoggleAxes: {
          xAxis: 'Kierto X',
          yAxis: 'Kierto Y',
          zAxis: 'Kierto Z',
          off: 'Pois päältä',
          half: 'Puoliksi',
          full: 'Täysi',
          none: 'Ei mitään',
        },
        visualToggleName: 'Nimi',
        visualToggleTechnicalRoom: 'Tekninen tila',
        visualToggleSelectRoom: 'Valitse tekninen tila',
        visualToggleBuildingRequired: 'Rakennus on pakollinen',
        visualToggleTechnicalRoomRequired: 'Tekninen tila on pakollinen',
        visualToggleDeviceRequired: 'Laite on pakollinen',
        feedback: {
          visualToggleDeleteConfirm:
            'Haluatko varmasti poistaa tämän Visual Toggle -laitteen?',
          visualToggleDeleteSuccess:
            'Visual Toggle -laite poistettu onnistuneesti',
          visualToggleDeleteError:
            'Virhe yritettäessä POISTAA Visual Toggle -laitetta',
          visualToggleDataKey: 'Datan avain puuttuu',
          visualToggleTrigger: 'Laukaisin puuttuu',
          visualToggleProperty: 'Ominaisuus on pakollinen.',
          visualToggleValue: 'Arvo on pakollinen.',
          visualToggleUpdated: 'Visual Toggle -laite päivitetty onnistuneesti',
          visualToggleCreated: 'Visual Toggle -laite luotu onnistuneesti',
          visualToggleSaveError:
            'Virhe yritettäessä TALLENTAA Visual Toggle -laitetta',
        },
      },
      list: {
        header: 'Laitehallinta',
        addButton: 'Lisää laite',
        emptyState: 'Laitteita ei löytynyt.',
        searchPlaceholder: 'Hae laitteita…',
        backButton: 'Takaisin laitteisiin',
      },
      validation: {
        nameRequired: 'Laitteen nimi vaaditaan',
        sensorTagMissing: 'Sensor-tagi puuttuu aiheen {{index}} kohdalla.',
        sensorTagTooShort:
          'Sensor-tagin pituuden on oltava vähintään 3 merkkiä (aihe {{index}}).',
      },
      feedback: {
        updateSuccess: 'Laite päivitetty onnistuneesti',
        updateError: 'Virhe laitteen PÄIVITYKSESSÄ',
        createSuccess: 'Laite luotu onnistuneesti',
        installSuccess: 'Laite asennettiin onnistuneesti',
        createError: 'Virhe laitteen LUONNISSA',
        duplicateDevice: 'Laite tällä sarjanumerolla on jo olemassa.',
        saveError: 'Virhe laitteen TALLENNUKSESSA',
        missingAttributes: 'Vaaditut laiteattribuutit puuttuvat',
        validationError: 'Laitteen validointivirhe',
        serviceUnavailable:
          'Palvelu on tilapäisesti poissa käytöstä. Yritä uudelleen myöhemmin.',
        bulkInstallSummary:
          'Asennettu: {installed}. Duplikaatit: {duplicates}. Epäonnistuneet: {failed}.',
      },
      deviceControls: {
        title: 'Laitteen ohjaus',
        send: 'Lähetä',
        updateSuccessMessage: 'Asetuspiste päivitetty onnistuneesti',
        updateSuccessTitle: 'Onnistui',
        updateErrorTitle: 'Virhe',
        updateErrorMessage: 'Asetuspisteen päivitys epäonnistui',
        hideAdvanced: 'Piilota lisäasetukset',
        showAdvanced: 'Näytä lisäasetukset ({count} laitetta)',
        current: 'Arvo',
        range: 'Väliltä',
        duration: 'Kesto (tuntia)',
        durationHelp: 'Asetusarvo palaa aikatauluun tämän jälkeen',
        comment: 'Kommentti',
        commentPlaceholder: 'Miksi tämä ohitetaan?',
        notLogged: 'Asetusarvo päivitettiin, mutta ohitusta ei voitu kirjata',
      },
    },
    eosDevices: {
      energyCategories: {
        electricityGrid: 'Sähkö (verkko)',
        electricityGridExport: 'Verkkoon syötetty sähkö',
        districtHeating: 'Kaukolämpö',
        districtCooling: 'Kaukojäähdytys',
        fossilFuels: 'Fossiiliset polttoaineet',
        biofuels: 'Biopolttoaineet',
        solarPV: 'Aurinkosähkö',
        solarThermal: 'Aurinkolämpö',
        otherRenewables: 'Muut uusiutuvat (tuuli, geoterminen)',
        wasteHeat: 'Hukkalämpö',
      },
      list: { header: 'EOS-laitteet' },
      validation: {
        sensorTagMissing: 'Sensor-tagi puuttuu aiheen {{index}} kohdalla.',
        sensorTagTooShort:
          'Sensor-tagin pituuden on oltava vähintään 3 merkkiä (aihe {{index}}).',
      },
      feedback: {
        updateSuccess: 'Laite päivitetty onnistuneesti',
        updateError: 'Virhe laitteen PÄIVITYKSESSÄ',
        createSuccess: 'Laite luotu onnistuneesti',
        createError: 'Virhe laitteen LUONNISSA',
        saveError: 'Virhe laitteen TALLENNUKSESSA',
      },
    },
    editDevice: {
      newTitle: 'Uusi laite',
      deviceName: 'Laitteen nimi',
      deviceDescription: 'Laitteen kuvaus',
      deviceProfile: 'Laitteen profiili',
      selectDeviceProfile: '- Valitse laitteen profiili',
      setpointRange: 'Setpoint-alue',
      setpointRangeInfo:
        'Määritä anturitagin ylä- ja ala-setpoint-arvot sekä askelkoko setpointien välillä.',
      minSetpoint: 'Alhainen Setpoint',
      maxSetpoint: 'Korkea Setpoint',
      stepSize: 'Askelkoko',
      controlMode: {
        label: 'Ohjaustila',
        info: 'Määrittää, miten laitetta säädetään, kun ohjaus käynnistyy.\nAskel: Säätää setpointia asteittain ylös/alas askelkoon verran ajokertaa kohden, min/max-rajojen sisällä.\nBinäärinen: Hyppää suoraan maksimiin (enemmän lämmitystä/ilmanvaihtoa) tai minimiin (vähemmän). On/off-ohjaus.\nAikataulu: Noudattaa vain aukioloaikoja — max niiden sisällä, min niiden ulkopuolella. Ohittaa ASPA-toiminnot.\nSetpoint: Kirjoittaa halutun setpointin suoraan, rajattuna min/max-arvoihin. Päivittää vain, kun poikkeama ylittää ±0,1.',
        step: 'Askel',
        binary: 'Binäärinen',
        schedule: 'Aikataulu',
        setpoint: 'Setpoint',
      },
      operatingHoursOnly: 'Ohjataan vain käyttöaikana',
      dynamicSetpoints: {
        label: 'Dynaamiset setpointit',
        info: 'Dynaamiset setpointit antavat laitteen ohittaa setpoint-alueensa muiden anturiarvojen perusteella. Kun sensor-tagin anturiarvo täyttää ehdon (operaattori + kynnysarvo), käytetään rivin alhaista ja korkeaa setpointia sekä askelkokoa laitteen normaalin setpoint-alueen sijaan.\nSensor-tagi: valvottava sensor-tagi (esim. jäähdytyspatterin ohjaus).\nOperaattori/kynnysarvo: ehto, jonka on täytyttävä, jotta ohitus on aktiivinen.\nAlhainen/korkea setpoint ja askelkoko: setpoint-alue, joka on voimassa niin kauan kuin ehto täyttyy.',
        add: 'Lisää dynaaminen setpoint',
        deleteTitle: 'Poista dynaaminen setpoint',
        confirmDelete: 'Haluatko varmasti poistaa tämän dynaamisen setpointin?',
        operator: 'Operaattori',
        threshold: 'Kynnysarvo',
        validationError:
          'Kaikki kentät on täytettävä, jotta dynaaminen setpoint voidaan lisätä.',
        fieldRequired: 'Pakollinen',
      },
      controllerSettings: 'Ohjaimen asetukset',
      status: {
        active: 'Aktiivinen',
        displayInZone: 'Näytä vyöhykkeessä',
      },
      display: 'Näyttö',
      icon: 'Kuvake',
      deviceType: {
        label: 'Laitetyyppi',
        selectDefault: '- Valitse laitetyyppi -',
        sensor: 'Sensori',
        controller: 'Ohjain',
      },
      dataReceiver: {
        label: 'Datavastaanotin',
        selectDefault: '- Valitse datavastaanotin',
        info: 'Määritä, mikä vastaanotin vastaanottaa tämän laitteen ohjausarvot.',
      },
      deviceCategory: {
        label: 'Laitekategoria',
        selectDefault: 'Valitse kategoria',
      },
      valueMap: 'Arvomapping',
      setValueMapping: 'Aseta arvomapping',
      mappedAttribute: {
        label: 'Kartoitettu attribuutti',
        attribute: 'Attribuutti',
        numberValue: 'Numero',
        textValue: 'Teksti',
        duplicateValueMapping:
          'Tämä arvo on jo määritetty toiselle ominaisuudelle.',
        cancelEditValueMapping: 'Peruuta',
        removeValueMapping: 'Poista',
        editValueMapping: 'Muokkaa',
        deleteTitle: 'Poista arvomappailu',
        confirmDeleteValueMapping:
          'Haluatko varmasti poistaa tämän arvomappingin?',
        confirmDeleteMappedAttributeTitle: 'Poista kartoitettu attribuutti',
        confirmDeleteMappedAttribute:
          'Haluatko varmasti poistaa tämän kartoitettun attribuutin?',
      },
      topics: 'Aiheet',
      inspectDevice: 'Tarkastele laitetta',
      deleteButton: {
        deleting: 'Poistetaan…',
        label: 'Poista laite',
      },
      confirmDelete: 'Haluatko varmasti poistaa tämän laitteen?',
      title: 'Muokkaa laitetta',
    },
    editEosDevice: {
      title: 'Muokkaa EOS-laitetta',
      newTitle: 'Uusi EOS-laite',
      deviceName: 'Laitteen nimi',
      topics: 'Aiheet',
      deviceDescription: 'Laitteen kuvaus',
      active: 'Aktiivinen',
      producingPower: 'Tuotantoteho',
      includeInBaseline: 'Sisällytä perustilanteeseen',
      deviceSettings: 'Laiteasetukset',
      energyCategory: { label: 'Energialuokka' },
      provider: {
        label: 'Toimittaja',
        required: 'Toimittaja vaaditaan kaukolämmölle',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Rakennus',
      allBuildings: 'Kaikki rakennukset',
      sensorTypes: {
        HEAT: 'Lämpö',
        LIGHT: 'Valo',
        HVAC: 'HVAC',
        PRODUCTION: 'Tuotanto',
        OFFICE: 'Toimisto',
        OTHER: 'Muu',
      },
      icon: 'Kuvake',
      deviceType: {
        label: 'Laitetyyppi',
        selectDefault: '- Valitse laitetyyppi -',
        eosSensor: 'EOS-sensori',
        eosSource: 'EOS-lähde',
      },
      sensorConfiguration: 'Sensorin asetukset',
      deviceCategory: {
        label: 'Laitekategoria',
        selectDefault: 'Valitse kategoria',
      },
      sources: 'Lähteet',
      inspectDevice: 'Tarkastele laitetta',
      deleteButton: {
        deleting: 'Poistetaan…',
        label: 'Poista EOS-laite',
      },
      confirmDelete: 'Haluatko varmasti poistaa tämän laitteen?',
    },
    categories: {
      list: {
        header: 'Kategoriat',
        addButton: 'Lisää kategoria',
        emptyState: 'Kategoriota ei löytynyt.',
        searchPlaceholder: 'Hae kategorioita…',
        backButton: 'Takaisin kategorioihin',
      },
      feedback: {
        updateSuccess: 'Kategoria päivitetty onnistuneesti',
        updateError: 'Virhe kategorian PÄIVITYKSESSÄ',
        createSuccess: 'Kategoria luotu onnistuneesti',
        createError: 'Virhe kategorian LUONNISSA',
        saveError: 'Virhe kategorian TALLENNUKSESSA',
      },
    },
    editCategory: {
      parentCategory: 'Yläkategoria',
      legend: 'Kieli',
      categoryName: 'Kategorian nimi:',
      languageType: 'Kielityyppi:',
      selectLanguage: 'Valitse kieli',
      categoryDescription: 'Kategorian kuvaus:',
      deleteCategory: 'Poista kategoria',
      deleteConfirm: 'Haluatko varmasti poistaa tämän kategorian?',
      categoryType: 'Kategoriatyyppi',
      validation: {
        categoryRequired: 'Vähintään yksi kategoriatyyppi vaaditaan',
        languageRequired: 'Kieli vaaditaan',
      },
      languageOptions: {
        en: 'Englanti',
        no: 'Norja',
        se: 'Ruotsi',
        de: 'Saksa',
        fr: 'Ranska',
        es: 'Espanja',
      },
      categoryTypes: {
        device: 'Laite',
        zone: 'Vyöhyke',
        service: 'Palvelu',
        resource: 'Resurssi',
        activity: 'Aktiviteetti',
      },
    },
    userManagement: {
      auditLogs: {
        viewed: 'Luettu',
        doneBy: 'Tekijä',
        noAccess:
          'Tarvitset tason 4 (järjestelmänvalvoja) tai korkeamman nähdäksesi tarkastuslokit.',
      },
      auditChanges: {
        readQuery: 'Mitä luettiin',
        title: 'Mitä muutettiin',
        field: 'Kenttä',
        before: 'Ennen',
        after: 'Jälkeen',
        created: 'Luotu',
        updated: 'Päivitetty',
        deleted: 'Poistettu',
        empty: 'Tälle pyynnölle ei kirjattu tietokantamuutoksia.',
        more: 'Tietueita muutettiin enemmän kuin tässä näytetään.',
        hidden: 'Piilotettu',
        largeValue: 'Suuri arvo',
        items: 'kohdetta',
        sentData: 'Lähetetyt tiedot',
      },
      list: {
        header: 'Käyttäjähallinta',
        addButton: 'Lisää käyttäjä',
        emptyState: 'Käyttäjiä ei löytynyt.',
        searchPlaceholder: 'Hae käyttäjiä…',
        backButton: 'Takaisin käyttäjiin',
      },
      feedback: {
        fetchError: 'Virhe käyttäjien hakemisessa',
        updateSuccess: 'Käyttäjä päivitetty onnistuneesti',
        updateError: 'Virhe käyttäjän PÄIVITYKSESSÄ',
        createSuccess: 'Käyttäjä luotu onnistuneesti',
        createError: 'Virhe käyttäjän LUONNISSA',
        saveError: 'Virhe käyttäjän TALLENNUKSESSA',
      },
    },
    editUser: {
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      userInformation: 'Käyttäjän tiedot',
      mobileNumber: 'Matkapuhelin',
      email: 'Sähköposti',
      password: 'Salasana',
      enovaOrganization: 'Organisaatio',
      enovaOrganizationNumber: 'Y-tunnus',
      enovaPersonalGuid: 'Enova GUID',
      azureAccount: 'Azure-tilin ID',
      role: 'Rooli',
      active: 'Aktiivinen',
      acceptEmails: 'Hyväksy sähköpostit',
      receiveEmails: 'Käyttäjä saa järjestelmän sähköposteja',
      canLogin: 'Käyttäjä voi kirjautua sisään',
      hideFeedback: 'Piilota palautteet',
      hidePopups: 'Piilota palautepop-upit',
      changePassword: 'Vaihda salasana',
      successUpdatePassword: 'Salasana päivitetty',
      errorUpdatePassword: 'Salasanan päivitys epäonnistui',
      passwordFeedback: 'Salasanan on oltava vähintään 8 merkkiä pitkä',
      addNew: 'Lisää uusi käyttäjä',
      calendarSetup: 'Kalenterin asetukset',
      calendarStartOfDay: 'Päivän alku (kalenterinäkymässä)',
      calendarEndOfDay: 'Päivän loppu',
      tenantAccess: {
        header: 'Vuokraajan käyttöoikeus',
        label: 'Vuokraaja',
        addAccess: 'Lisää käyttöoikeus',
        selectTenant: '- Valitse vuokraaja -',
        assignedTenants: 'Määritetyt vuokraajat',
        fetchFailed: 'Vuokraajien haku epäonnistui',
        feedback: {
          pleaseSelect: 'Valitse vuokraaja',
          alreadyAdded: 'Vuokraaja on jo lisätty',
        },
      },
      deleteUser: {
        label: 'Poista käyttäjä',
        deleting: 'Poistetaan…',
      },
      confirmDelete: 'Haluatko varmasti poistaa tämän käyttäjän?',
      activityLog: 'Toimintaloki',
    },
    integrationOverview: {
      edit: {
        details: {
          legend: 'Tiedot',
          nameLabel: 'Nimi',
          activeLabel: 'Aktiivinen',
        },
        access: {
          legend: 'Käyttöoikeus',
          accessLevelLabel: 'Käyttötaso',
          dateFromLabel: 'Alkupäivä',
          dateToLabel: 'Loppupäivä',
          accessLevelOptions: {
            noAccess: 'Ei pääsyä',
            readOnly: 'Vain luku',
            readAndWrite: 'Luku ja kirjoitus',
            admin: 'Ylläpitäjä',
          },
        },
        secrets: {
          legend: 'Avaimet',
          revealButton: 'Näytä',
          publicKeyLabel: 'Julkinen avain',
          secretKeyLabel: 'Salainen avain',
        },
      },
      feedback: {
        updateSuccess: 'Integraatio päivitetty',
        createSuccess: 'Integraatio luotu',
        saveError: 'Tallennus epäonnistui',
        fetchSecretsError: 'Avainhaku epäonnistui',
        fetchIntegrationsError: 'Integraatioiden haku epäonnistui',
      },
    },
    themeSettings: {
      header: {
        title: 'Teemat',
        subtitle: 'Luo ja hallinnoi yrityksesi visuaalisia teemoja',
      },
      feedback: {
        activatedSuccess: 'Teema {themeName} aktivoitu',
        deletedSuccess: 'Teema poistettu',
        updatedSuccess: 'Teema päivitetty',
        createdSuccess: 'Teema luotu',
      },
      card: {
        customize: 'Mukauta',
        fallbackDescription: '{name}-teema',
        confirmDelete: 'Haluatko varmasti poistaa teeman "{name}"?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Auringonlasku-oranssi',
          description:
            'Lämpimät oranssin ja korallin sävyt hiekkaisilla aksenteilla',
        },
        oceanBlue: {
          name: 'Valtamerensininen',
          description: 'Raikkaat siniset sävyt valtameren inspiroimina',
        },
        crimsonRed: {
          name: 'Karmiininpunainen',
          description: 'Rohkea karmiini energisten punaisten sävyjen ympärillä',
        },
        forestGreen: {
          name: 'Metsänvihreä',
          description:
            'Rauhoittavat metsänvihreät sävyt luonnollisilla aksenteilla',
        },
        blackAndWhite: {
          name: 'Mustavalkoinen',
          description:
            'Ajaton mustan ja valkoisen kontrasti modernille ilmeelle',
        },
        classicGray: {
          name: 'Klassinen harmaa',
          description:
            'Ammattimainen harmaa teema hienovaraisilla kontrasteilla',
        },
        modernWhite: {
          name: 'Moderni valkoinen',
          description:
            'Ajaton valkoinen puhtaaseen, minimalistiseen estetiikkaan',
        },
      },
      dialog: {
        editHeader: 'Muokkaa teemaa',
        createHeader: 'Luo teema',
        createTitle: 'Luo uusi teema',
        createDescription: 'Suunnittele oma teema väreilläsi ja tyylilläsi',
        namePlaceholder: 'Teemasi nimi',
        descriptionPlaceholder: 'Kuvaile teemaasi (valinnainen)',
        iconHover: 'Kuvake hiiren päällä',
        nameRequired: 'Teeman nimi vaaditaan',
        customSuffix: '(Mukautettu)',
      },
    },
    vendor: {
      title: 'Yleiset',
      form: {
        name: 'Nimi',
        contactDetails: 'Yhteystiedot',
        street: 'Katu',
        postcode: 'Postinumero',
        city: 'Kaupunki',
        country: 'Maa',
        timezone: 'Aikavyöhyke',
        selectTimezone: 'Aseta aikavyöhyke',
        organizationNumber: 'Y-tunnus',
        phone: 'Yhteyspuhelin',
        email: 'Yhteyssähköposti',
        website: 'Yrityksen verkkosivut',
        languageDefault: 'Oletuskieli',
        selectLanguage: 'Aseta kieli',
      },
      modules: {
        title: 'Moduulit',
        threeDView: '3D-näkymä',

        requiredAttributes: {
          title: 'Pakolliset kentät',
          firstName: 'Etunimi',
          lastName: 'Sukunimi',
          phone: 'Puhelin',
          email: 'Sähköposti',
        },
        buildingAutomation: {
          title: 'Rakennusautomaatio',
          sastechTenantId: 'Sastech-vuokraajan ID',
          ignitionProjectName: 'Ignition-projektin nimi',
          gridRegion: 'Sähköalue',
          selectGridRegion: '- Valitse alue -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Julkinen näyttö',
          loginToDisplay: 'Kirjaudu näyttöön',
          invalidPassword: 'Virheellinen salasana. Yritä uudelleen.',
          password: 'Salasana',
          publicLink: 'Julkisen näytön linkki:',
          description:
            'Näytä rakennuksen keskeiset mittarit julkisella näytöllä ilman käyttöliittymää',
          placeholder: 'Anna uusi salasana',
          leaveBlankHint:
            'Jätä tyhjäksi, jos haluat säilyttää nykyisen salasanan.',
          copyButton: 'Kopioi',
          copySuccess: 'Linkki kopioitu leikepöydälle',
          saveVendorFirst: 'Tallenna toimittaja luodaksesi tunnisteen',
          regenerateButton: 'Luo uusi tunniste',
          regenerateWarning: 'Varoitus: Tämä mitätöi nykyisen linkin',
          confirmRegenerate:
            'Haluatko varmasti luoda uuden tunnisteen? Nykyinen linkki mitätöidään.',
          tokenRegenerated: 'Tunniste luotu onnistuneesti',
          tokenRegenerateFailed: 'Tunnisteen luonti epäonnistui',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Yksityisyys ja anonymisointi',
        activateAnonymizing: 'Ota anonymisointi käyttöön',
        privacyPolicyText: 'Määritä täällä anonymisoinnin aikaväli',
        monthsToKeepData: 'Kuinka monta kuukautta data säilytetään',
      },
      keyAccountManager: {
        title: 'Avainasiakaspäällikkö',
        notAssigned: 'Ei määritetty',
      },
      tenantStatus: {
        title: 'Vuokraajan tila',
        tenantIsActive: 'Vuokraaja on aktiivinen',
        status: 'Tila',
        options: {
          development: '1. Kehitys',
          readyForProduction: '2. Valmis tuotantoon',
          production: '3. Tuotanto (järjestelmä)',
          deleted: 'Poistettu',
        },
        markedForDeletion: 'Merkitty poistettavaksi',
        vendorDeletionTitle: 'Toimittajan poisto',
        vendorDeletionDescription:
          'Toimittaja poistetaan vain, jos se on merkitty poistettavaksi, tila on "poistettu" ja se on inaktiivinen. Lisäksi viimeisestä muutoksesta on kulunut vähintään 30 päivää.',
      },
      vendorIdLabel: 'Toimittajan ID',
      successMessage: 'Toimittaja päivitetty onnistuneesti',
      successMessagePassword: 'Toimittaja päivitetty (salasana vaihdettu)',
      errorMessage: 'Toimittajan päivitys epäonnistui',
    },
    imageUpload: {
      uploadImage: 'Lataa kuva',
      noFileSelected: 'Ei tiedostoa valittuna',
      uploading: 'Ladataan…',
      fileSizeExceeded: 'Tiedoston koko ylittää rajan {{size}} Mt.',
      invalidFileType: 'Virheellinen tiedostotyyppi. Valitse kuva.',
      uploadFailed: 'Lataus epäonnistui. Yritä uudelleen',
      bytes: 'tavua',
      dropToReplace: 'Pudota kuva korvataksesi',
      dragHint: 'Vedä ja pudota tähän korvataksesi',
      fromFileCloud: 'Tiedostopilvi',
      chooseFromFileCloud: 'Valitse Tiedostopilvestä',
      convertingHeic: 'Muunnetaan HEIC kuvaa…',
      heicConversionFailed:
        'HEIC kuvan muuntaminen epäonnistui. Kokeile JPEG tai PNG tiedostoa.',
      uploadProgress: 'Ladataan {{done}}/{{total}}…',
      uploadFailedFiles: 'Ei voitu ladata: {{names}}',
    },

    fileUpload: {
      uploadImage: 'Lataa tiedosto',
      noFileSelected: 'Ei tiedostoa valittuna',
      uploading: 'Ladataan…',
      fileSizeExceeded: 'Tiedoston koko ylittää rajan {{size}} Mt.',
      invalidFileType: 'Virheellinen tyyppi. Valitse kelvollinen tiedosto.',
      uploadFailed: 'Lataus epäonnistui. Yritä uudelleen',
      fileAlreadyUploaded: 'Tiedosto on jo ladattu',
      uploadFile: 'Lataa tiedosto',
      viewUploadedFile: 'Näytä ladattu tiedosto',
      uploadNewFile: 'Lataa uusi tiedosto',
      fileLabel: 'Tiedosto:',
      sizeLabel: 'Koko:',
    },
    fileCloud: {
      title: 'Tiedostopilvi',
      storageTitle: 'Tilasto',
      nameLabel: 'Nimi',
      folderLabel: 'Kansio',
      sizeLabel: 'Koko',
      dateLabel: 'Päivämäärä',
      buildingLabel: 'Rakennus',
      currentPath: 'Nykyinen polku',
      rootLabel: 'Koti',
      selectedLabel: 'valittu',
      gridViewLabel: 'Ruudukkonäkymä',
      listViewLabel: 'Luettelonäkymä',
      header:
        'Tallenna, järjestä ja jaa tiedostoja turvallisesti organisaatiossasi',
      uploadFiles: {
        dropZonePrompt: 'Vedä ja pudota tiedostot tähän',
        selectedFilesHeader: 'Valitut tiedostot:',
        uploadButton: 'Lataa',
        uploadFilesLabel: 'Lataa tiedostoja',
        uploadFolderLabel: 'Lataa kansio',
        uploadProgress: 'Ladataan {{done}}/{{total}} tiedostoa…',
      },
      noFiles: 'Vedä ja pudota tiedostoja',
      noBuildings: 'Rakennuksia ei saatavilla.',
      menu: {
        download: 'Lataa',
        rename: 'Nimeä uudelleen',
        delete: 'Poista',
        setBuilding: 'Aseta rakennus',
        clearBuilding: 'Tyhjennä rakennus',
      },
      dialog: {
        buildingTitle: 'Valitse rakennus',
        cancelButton: 'Peruuta',
        newFolderName: 'Kansion nimi',
        createFolder: 'Luo kansio',
        renameFolder: 'Nimeä kansio uudelleen',
        confirmDeleteTitle: 'Vahvista poisto',
        confirmDeleteMessage: 'Haluatko varmasti poistaa valitun tiedoston?',
        confirmFolderDeleteMessage:
          'Haluatko varmasti poistaa valitun kansion ja kaiken sen sisällön?',
        invalidFolderName:
          'Kansion nimi sisältää virheellisiä merkkejä tai on tyhjä.',
        duplicateFolderName: 'Samanniminen kansio on jo olemassa.',
        confirmDeleteSelectedMessage:
          'Haluatko varmasti poistaa valitut tiedostot?',
      },
      feedback: {
        // existing
        fileDeleted: 'Tiedosto poistettu onnistuneesti',
        buildingCleared: 'Rakennus tyhjennetty onnistuneesti',
        buildingAssigned: 'Rakennus liitetty onnistuneesti',
        buildingUpdateError: 'Rakennusliitoksen päivitys epäonnistui.',

        // Restore file
        fileRestored: 'Tiedosto palautettu onnistuneesti.',
        restoreSuccessfulTitle: 'Palautus onnistui',
        restoreErrorMessage: 'Tiedoston palauttaminen epäonnistui.',
        restoreErrorTitle: 'Palautusvirhe',

        // Empty garbage
        garbageEmptied: 'Roskakori tyhjennetty onnistuneesti.',
        emptyGarbageSuccessfulTitle: 'Roskakorin tyhjennys onnistui',
        emptyGarbageErrorMessage: 'Roskakorin tyhjentäminen epäonnistui.',
        emptyGarbageErrorTitle: 'Roskakorin tyhjennysvirhe',

        // Move folder to garbage
        folderMovedToGarbage: 'Kansio siirretty roskakoriin onnistuneesti.',
        moveFolderToGarbageSuccessfulTitle: 'Siirto roskakoriin onnistui',
        moveFolderToGarbageErrorMessage:
          'Kansion siirtäminen roskakoriin epäonnistui.',
        moveFolderToGarbageErrorTitle: 'Siirtovirhe',

        // Rename folder
        folderRenamed: 'Kansio nimetty uudelleen onnistuneesti.',
        renameFolderSuccessfulTitle: 'Nimenmuutos onnistui',
        renameFolderErrorMessage: 'Kansion uudelleennimeäminen epäonnistui.',
        renameFolderErrorTitle: 'Nimenmuutosvirhe',

        // Move folder
        folderMoved: 'Kansio siirrettiin onnistuneesti.',
        moveFolderSuccessfulTitle: 'Siirto onnistui',
        moveFolderErrorMessage: 'Kansion siirto epäonnistui.',
        moveFolderErrorTitle: 'Siirtovirhe',

        // Delete file
        deleteSuccessfulTitle: 'Poisto onnistui',
        deleteErrorMessage: 'Tiedoston poistaminen epäonnistui.',
        deleteErrorTitle: 'Poistovirhe',

        // Move file
        moveFileErrorMessage: 'Tiedoston siirtäminen epäonnistui.',
        moveFileErrorTitle: 'Siirtovirhe',

        // Create folder
        createFolderErrorMessage: 'Kansion luominen epäonnistui.',
        createFolderErrorTitle: 'Kansion luontivirhe',

        // Upload
        uploadSuccessfulMessage: 'Tiedostojen lataus onnistui.',
        uploadSuccessfulTitle: 'Lataus onnistui',
        uploadErrorTitle: 'Latausvirhe',
      },

      newFolder: 'Uusi kansio',
      confirmDeleteFolder:
        'Haluatko varmasti poistaa tämän kansion ja kaiken sen sisällön?',
      moveToRoot: 'Siirrä juurihakemistoon',
    },
    feedback: {
      vendorLoad: {
        title: 'Virhe',
        message: 'Toimittajatietojen lataus epäonnistui',
      },
    },
    degreeDays: {
      error: 'Rakennukselta puuttuu GPS-koordinaatit',
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Lähetä palautetta',
    close: 'Sulje',
    messageLabel: 'Viesti',
    placeholder: 'Kirjoita palautteesi tähän…',
    screenshotTitle: 'Lataa kuvakaappaus',
    send: 'Lähetä',
    infoPrefix: 'Lisätietoja löydät',
    helpCenter: 'Ohjekeskus',
    statusPage: 'Tilasivu',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        'Yhtään rakennustarkastusta ei ole valittu poistettavaksi.',
      deleteConfirmMessage:
        'Haluatko varmasti poistaa tämän rakennustarkastuksen? Tätä toimintoa ei voi peruuttaa.',
      deleteSuccessMessage: 'Rakennustarkastus on poistettu.',
      deleteErrorMessage: 'Rakennustarkastusta ei voitu poistaa.',
      updateSuccessMessage: 'Rakennustarkastus on päivitetty.',
      createSuccessMessage: 'Rakennustarkastus on luotu.',
      failedToLoadMessage:
        'Rakennustarkastuksia ei voitu ladata. Yritä myöhemmin uudelleen.',
      saveErrorMessage:
        'Rakennustarkastusta ei voitu tallentaa. Yritä myöhemmin uudelleen.',
      buildingErrorMessage: 'Valitse rakennus tarkastusta varten.',
      buildingTypeErrorMessage: 'Valitse rakennustyyppi tarkastusta varten.',
      failedToLoadBuildingsMessage:
        'Rakennuksia ei voitu ladata. Yritä myöhemmin uudelleen.',
      calculationsCompleteMessage: 'Laskelmat valmiit',
      //Header
      title: 'Rakennustarkastus',
      subtitle: 'Suorita rakennustarkastus käyttämällä alla olevaa lomaketta',
      newInspectionLabel:
        'Uusi tarkastus – tallenna aktivoidaksesi lisää valintoja.',
      reportLabel: 'Raportti',
      actionsLabel: 'Toimenpiteet',
      generalLabel: 'Yleiset tiedot',
      //Info
      status: {
        statusLabel: 'Tila',
        draft: 'Luonnos',
        completed: 'Valmis',
        inReview: 'Tarkastuksessa',
      },
      buildingLabel: 'Rakennus',
      buildingTypeLabel: 'Rakennustyyppi (SFS-standardi)',
      notesLabel: 'Huomautukset',
      buildingTypes: {
        label: {
          smallHouse: 'Pientalo',
          apartmentBlock: 'Kerrostalo',
          kinderGarden: 'Päiväkoti',
          officeBuilding: 'Toimistorakennus',
          schoolBuilding: 'Koulurakennus',
          universityCollege: 'Yliopisto / Korkeakoulu',
          hospital: 'Sairaala',
          nursingHome: 'Hoivakoti',
          hotel: 'Hotelli',
          sportsBuilding: 'Urheilurakennus',
          commercialBuilding: 'Liikerakennus',
          culturalBuilding: 'Kulttuurirakennus',
          lightIndustryWarehouse: 'Kevyt teollisuus / Varastorakennus',
        },
        description: {
          smallHouse:
            'Omakotitalo, paritalo, rivitalo, ketjutalo tai muu pieni asuinrakennus.',
          apartmentBlock:
            'Asuinrakennus, jossa on kaksi tai useampia kerroksia, mukaan lukien suuret monikerroksiset rivitalot.',
          kinderGarden:
            'Rakennukset, jotka on tarkoitettu päiväkoteihin tai varhaiskasvatukseen.',
          officeBuilding:
            'Yksinkertaiset toimistot, toimistot, joissa on ilmanvaihto ja jäähdytys, tai näyttely- ja kongressirakennukset.',
          schoolBuilding:
            'Opetustilat, mukaan lukien koulut, joissa on uimahalli tai liikuntasali.',
          universityCollege:
            'Yliopisto- tai korkeakoulurakennukset, laboratoriot tai tutkimuslaitokset.',
          hospital:
            'Sairaalat, potilashotellit tai lääketieteelliseen käyttöön tarkoitetut laboratoriotilat.',
          nursingHome: 'Hoivakodit pitkäaikaishoitoa ja asumista varten.',
          hotel: 'Hotellit, ravintolarakennukset tai muut majoitusrakennukset.',
          sportsBuilding:
            'Liikuntahallit, uimahallit ja muut urheilutilat, joissa on pukuhuoneet ja suihkutilat.',
          commercialBuilding:
            'Kaupat, liiketilat, joissa on kylmä- tai pakastetilat, tai huoltoasemat.',
          culturalBuilding:
            'Elokuvateatterit, museot, kirjastot ja uskonnolliset rakennukset.',
          lightIndustryWarehouse:
            'Teollisuusrakennukset, varastot, kalastus- tai maatalousrakennukset, energiantuotantolaitokset tai muut työpajat.',
        },
      },
      mainTabs: {
        info: 'Tiedot',
        climate: 'Ilmasto',
        zones: 'Vyöhykkeet',
        hvac: 'Ilmanvaihto ja toiminta',
        heatingCooling: 'Lämmitys ja jäähdytys',
        excessEnergy: 'Ylijäämäenergia',
        analytics: 'Analytiikka',
        attachments: 'Liitteet',
      },
      footerButtons: {
        next: 'Seuraava',
        previous: 'Edellinen',
      },
      climate: {
        averageMonthlyTemp: 'Kuukausittainen keskilämpötila (°C)',
        globalIrradiation: 'Kokonais­säteilyn määrä (kWh/m²)',
        diffuseIrradiation: 'Hajavalo­säteilyn määrä (kWh/m²)',
        albedo: 'Albedo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'Ilmanvaihtoyksiköt',
        operationalLoads: 'Käyttökuormat',
        productionEquipment: 'Tuotantolaitteet',
      },
      zoneManager: {
        area: 'Pinta-ala (m²)',
        noZonesCreatedYet: 'Yhtään aluetta ei ole vielä luotu',
        createZoneToBegin:
          'Luo alue aloittaaksesi rakennuksen vaipan tietojen keräämisen. Voit joko valita olemassa olevan rakennusalueen tai luoda uuden juuri tätä tarkastusta varten.',
        subTabs: {
          buildingEnvelope: 'Rakennuksen vaippa',
          windows: 'Ikkunat',
          doors: 'Ovet',
          gates: 'Portit',
          airLeakage: 'Ilmavuodot',
          thermalMass: 'Lämpömassa',
        },
        zoneSelector: {
          createFirstZone: 'Luo ensimmäinen vyöhyke',
          addZone: 'Lisää vyöhyke',
          deleteSelectedZone: 'Poista valittu vyöhyke',
          linked: 'Linkitetty',
        },
        zoneCreateModal: {
          zoneNameError: 'Vyöhykkeen nimi on pakollinen.',
          createNewZoneLabel: 'Luo uusi vyöhyke',
          linkExistingZoneLabel: 'Linkitä olemassa oleva vyöhyke',
          linkExistingZoneHelperText:
            'Valitse olemassa oleva vyöhyke liitettäväksi tähän tarkastukseen.',
          selectZonePlaceholder: 'Valitse vyöhyke...',
          createNewZoneHelperText:
            'Luo uusi vyöhyke, joka lisätään rakennukseen ja käytetään tässä tarkastuksessa.',
          zoneName: 'Vyöhykkeen nimi',
          description: 'Kuvaus',
          cancelButtonLabel: 'Peruuta',
          addZoneTitle: 'Lisää vyöhyke',
          zoneNameLabel: 'Alueen nimi',
          descriptionLabel: 'Kuvaus',
        },
        exteriorWalls: 'Ulkoseinät',
        helperWithHistory: {
          north: 'Pohjoinen',
          south: 'Etelä',
          east: 'Itä',
          west: 'Länsi',
          count: 'Lukumäärä',
          width: 'Leveys (m)',
          height: 'Korkeus (m)',
          addToArea: 'Lisää pinta-alaan (m²)',
          history: 'Historia',
          entry: ' laskelma',
          entries: ' laskelmaa',
          inputHistory: 'Laskentahistoria',
          helperTitle: 'Pinta-alalaskuri',
        },
        windows: {
          glassType: 'Lasityyppi',
          windowTypes: [
            'Ei mikään',
            'Yksinkertainen lasitus',
            'Kaksinkertainen lasitus',
            'Kaksinkertainen energialasi',
            'Kaksinkertainen auringonsuojalasi',
            'Kolminkertainen energialasi',
          ],
          totalWindowsArea: 'Ikkunoiden kokonaispinta-ala (m²)',
          sumOfAllWindowsSurfaces: 'Kaikkien ikkuna-alueiden summa',
          averageUValue: 'Keskimääräinen U-arvo (W/m²K)',
          averageUValueFormula: '(Σ(U × ala)) / Σ(ala)',
          winAreaAsPercentageOfFacade: 'Ikkuna-ala julkisivun prosentteina',
          winAreaAsPercentageOfFacadeFormula:
            'Ikkunoiden kokonaispinta-ala / Julkisivun kokonaispinta-ala × 100',
        },
        buildingEnvelope: {
          bra: 'Lämmitetty käyttöpinta-ala (m²)',
          floors: 'Kerrosten lukumäärä',
          floorHeight: 'Kerroksen korkeus (m)',
          indoorTemperature: 'Sisälämpötila (°C)',
          heatedVolume: 'Lämmitetty ilman tilavuus (m³)',
          heatedVolumeFormula: 'Lämmitetty käyttöpinta-ala × kerroksen korkeus',
          thermalBridge: 'Kylmäsilta',
          thermalBridgeFormula: 'Lämmitetty pinta-ala × normiarvo × kelvin',
          totalExternalWallArea: 'Ulkoseinien kokonaispinta-ala',
          totalExternalWallAreaFormula: 'Kaikkien ulkoseinäpintojen summa',
          thermalBridgeCoefficient: 'Kylmäsiltakerroin (W/mK)',
          extwWallConstruction: 'Ulkoseinärakenteen tyyppi',
          groundConditions: {
            title: 'Pohjaolosuhteet',
            options: {
              none: 'Ei mikään',
              clay: 'Savi',
              drySandGravel: 'Hiekka/sora (kuiva)',
              moistSandGravel: 'Hiekka/sora (kostea)',
              wetSandGravel: 'Hiekka/sora (märkä)',
              rock: 'Kallio',
              moraine: 'Moreeni',
              dryPeat: 'Turve (kuiva)',
              moistPeat: 'Turve (kostea)',
              wetPeat: 'Turve (märkä)',
              silt: 'Siltti',
              organicSoil: 'Orgaaninen maa',
            },
            heatCapacity: 'Lämpökapasiteetti (J/m²K)',
            thermalConductivity: 'Lämmönjohtavuus (W/mK)',
            groundTemperature: 'Maan lämpötila (°C)',
          },
          grossArea: 'Bruttopinta-ala (m²)',
          netArea: 'Nettopinta-ala (m²)',
          netAreaFormula: 'Seinäpinta-ala − Ikkunat − Ovet − Portit',
          wallConstruction: {
            title: 'Seinärakenne',
          },
          uValue: 'U-arvo (W/m²K)',
          shadingFactor: 'Varjostuskerroin',
          area: 'Pinta-ala (m²)',
          yearInstalled: 'Asennusvuosi',
          yearInstalledNone: 'Ei tietoa',
          yearInstalledBefore1949: 'Ennen vuotta 1949',
          yearInstalledFrom1997: 'Vuodesta 1997 alkaen',
          floor: {
            area: 'Lattian pinta-ala (m²)',
            uValue: 'Lattian U-arvo (W/m²K)',
            title: 'Lattia',
            options: {
              title: 'Lattiapinnoitteen tyyppi',
              standard: 'Standardi',
              tiles: 'Laatat (7 mm) + betoni',
              flooringChipBoard: 'Pinnoite (4 mm) + 22 mm lastulevy',
              flooringConcrete: 'Pinnoite (4 mm) + betoni',
              flooringLWA: 'Pinnoite (4 mm) + kevytsorabetonilaatta',
              parquetChipBoard: 'Parketti (14 mm) + 22 mm lastulevy',
              parquetConcrete: 'Parketti (14 mm) + betoni',
              parquetLWA: 'Parketti (14 mm) + kevytsorabetonilaatta',
              carpetChipBoard: 'Matto (10 mm) + 22 mm lastulevy',
              carpetConcrete: 'Matto (10 mm) + betoni',
              carpetLWA: 'Matto (10 mm) + kevytsorabetonilaatta',
            },
          },
          roof: {
            title: 'Katto',
            optionsTitle: 'Kattorakenne',
            area: 'Katon pinta-ala (m²)',
            uValue: 'Katon U-arvo (W/m²K)',
            options: [
              'Standardi',
              'Kompaktikatto, 200–250 mm betoni, 200 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 250 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 300 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 350 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 400 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 450 mm eriste',
              'Kompaktikatto, 200–250 mm betoni, 500 mm eriste',
              'Kompaktikatto, aaltopelti, 200 mm eriste',
              'Kompaktikatto, aaltopelti, 250 mm eriste',
              'Kompaktikatto, aaltopelti, 300 mm eriste',
              'Kompaktikatto, aaltopelti, 350 mm eriste',
              'Kompaktikatto, aaltopelti, 400 mm eriste',
              'Kompaktikatto, aaltopelti, 450 mm eriste',
              'Kompaktikatto, aaltopelti, 500 mm eriste',
              'Harjakatto, 48 mm kattokannattimet (9 % pinta-alasta), 200 mm eriste',
              'Harjakatto, 48 mm kattokannattimet (9 % pinta-alasta), 250 mm eriste',
              'Harjakatto, 48 mm kattokannattimet (9 % pinta-alasta), 300 mm eriste',
              'Harjakatto, 48 mm kattokannattimet (9 % pinta-alasta), 350 mm eriste',
              'Harjakatto, 48 mm kattokannattimet (9 % pinta-alasta), 400 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 200 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 250 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 300 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 350 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 400 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 450 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 500 mm eriste',
              'Harjakatto, I-palkkikannattimet (6 % pinta-alasta), 550 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 200 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 250 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 300 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 350 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 400 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 450 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 500 mm eriste',
              'Katto kylmällä ullakolla, 48 mm palkit (9 % pinta-alasta), 550 mm eriste',
            ],
          },
          basement: {
            title: 'Kellari',
            area: 'Kellarialue (m²)',
            wallHeight: 'Seinäkorkeus (m)',
            wallThickness: 'Seinän paksuus (m)',
            baseWallConstruction: 'Seinärakenne',
            wallUValue: 'U-arvo (W/m²K)',
            heatStorage: 'Lämmönvarastoinnin tyyppi',
            effectiveHeatCapacity: 'Efektiivinen lämpökapasiteetti (kJ/m²K)',
            floorConstruction: 'Lattiarakenne',
            baseWallConstructionType: 'Seinärakenteen tyyppi',
            baseWallConstructionOptions: [
              'Standardi',
              '200 mm betonia ja 100 mm eristettä',
              '200 mm betonia ja 150 mm eristettä',
              '200 mm betonia ja 200 mm eristettä',
              '200 mm betonia ja 250 mm eristettä',
              '200 mm betonia ja 300 mm eristettä',
              '300 mm betonia ja 100 mm eristettä',
              '300 mm betonia ja 150 mm eristettä',
              '300 mm betonia ja 200 mm eristettä',
              '300 mm betonia ja 250 mm eristettä',
              '300 mm betonia ja 300 mm eristettä',
            ],
            heatStorageTypes: [
              'Ei mikään',
              'Kevyt (< 50 Wh/m²K)',
              'Keskitaso (50–100 Wh/m²K)',
              'Raskas (100–150 Wh/m²K)',
              'Erittäin raskas (> 150 Wh/m²K)',
              'Betoni 100 mm',
              'Betoni 150 mm',
              'Betoni 200 mm',
              'Betoni 250 mm',
              'Betoni 300 mm',
              'Puu',
              'Kipsilevy',
            ],
            floorConstructionTypes: [
              'Ei mikään',
              'Standardi',
              'Betonilaatta maavaraisesti, 100 mm eriste',
              'Betonilaatta maavaraisesti, 150 mm eriste',
              'Betonilaatta maavaraisesti, 200 mm eriste',
              'Betonilaatta maavaraisesti, 250 mm eriste',
              'Betonilaatta maavaraisesti, 300 mm eriste',
              'Betonilaatta maavaraisesti, 350 mm eriste',
              'Betonilaatta maavaraisesti, 400 mm eriste',
              'Puurakenteinen välipohja, 200 mm eriste',
              'Puurakenteinen välipohja, 250 mm eriste',
              'Puurakenteinen välipohja, 300 mm eriste',
            ],
          },
        },
        doors: {
          title: 'Ovityyppi',
          yearInstalled: 'Asennusvuosi',
          totalArea: 'Ovien kokonaispinta-ala',
          totalAreaFormula: 'Kaikkien ovipintojen summa',
          avgUValue: 'Ovien keskimääräinen U-arvo',
          avgUValueFormula: '(Σ(U × ala)) / Σ(ala)',
          percentageOfFacade: 'Ovien pinta-ala julkisivun prosentteina',
          percentageOfFacadeFormula:
            'Ovien kokonaispinta-ala / Julkisivun kokonaispinta-ala × 100',
          doorTypes: [
            'Ei mitään',
            'Standardi',
            'Eristetty',
            'Normaali',
            'Hyvin eristetty',
            'Eristämätön',
          ],
        },
        gates: {
          title: 'Porttityyppi',
          yearInstalled: 'Asennusvuosi',
          totalArea: 'Porttien kokonaispinta-ala',
          totalAreaFormula: 'Kaikkien porttipintojen summa',
          avgUValue: 'Porttien keskimääräinen U-arvo',
          avgUValueFormula: '(Σ(U × ala)) / Σ(ala)',
          percentageOfFacade: 'Porttien pinta-ala julkisivun prosentteina',
          percentageOfFacadeFormula:
            'Porttien kokonaispinta-ala / Julkisivun kokonaispinta-ala × 100',
        },
        airLeakage: {
          airLeakageRate: 'Ilmavuoto (l/s·m², 50 Pa)',
          airChangeRate: 'Ilmanvaihtuvuus (ACH, 50 Pa)',
          naturalVentilation: 'Luonnollinen ilmanvaihto',
        },
        thermalMass: {
          buildingHeatCapacity: 'Rakennuksen kokonaislämpökapasiteetti',
          heatCapacitySelectTitle: 'Rakennustyyppi (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Kevyt välipohja, ohut lattianpäällyste, kevyet seinät',
          shortDescriptionSecondOption:
            'Akustoitu alakatto, matto betonin päällä, kevyet seinät',
          shortDescriptionThirdOption:
            'Vähän näkyvää betonia (20 %), parketti betonin päällä',
          shortDescriptionFourthOption: 'Pääosin näkyvää betonia (70 %)',
          shortDescriptionFifthOption:
            'Näkyvä betoni katossa, seinissä ja lattiassa',
          labelFirstOption: 'Erittäin kevyt rakennus',
          labelSecondOption: 'Kevyt rakennus',
          labelThirdOption: 'Keskiraskas rakennus',
          labelFourthOption: 'Raskas rakennus',
          labelFifthOption: 'Erittäin raskas rakennus',
          normalizedHeatCapacity: 'Normalisoitu lämpökapasiteetti [Wh/(m²·K)]',
          normalizedHeatCapacityHelper:
            'NS 3031 taulukon B.8 mukaan – Käytetään dynaamisessa energialaskennassa',
          interiorWalls: 'Sisäseinät',
          north: 'Pohjoinen',
          south: 'Etelä',
          east: 'Itä',
          west: 'Länsi',
          claddingTitle: 'Verhoustyypi',
          cladding: [
            'Mukautettu',
            'Standardi',
            'Betoni 100 mm (tai enemmän)',
            'Betoni 80 mm',
            'Kevytbetoni',
            'Kipsilevy 13 mm',
            'Kevyt tiili',
            'Kevytsorabetoni',
            'Massiivipuu (paksuus yli 40 mm)',
            'Puuverhous 15 mm',
            'Täystiili (raskas)',
          ],
          claddingSubText: 'Käyttäjän määrittelemä',
          internalConstruction: 'Sisärakenne',
          heatCapacity: 'Lämpökapasiteetti [Wh/m²K]',
          grade: 'Luokka',
          furniture: {
            title: 'Kalusteet',
            options: ['Ei mitään', 'Vakio', 'Kevyt', 'Keskitaso', 'Raskas'],
          },
          thermalHeatCapacityLabel: 'Rakennuksen lämpökapasiteetti',
          thermalHeatCapacityFormula:
            'Lämmitetty käyttöpinta-ala × normiarvo / 1000 (Normi: Ei mitään = 0, Kevyt = 40, Keskitaso = 60, Raskas = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Välipohjien pinta-ala (m²)',
          internalFloorsTooltip:
            'Sisäiset välipohjat kerrosten välillä: lämmitetty käyttöpinta-ala × (kerrokset − 1) / kerrokset',
        },
      },
    },
    report: {
      noReportYetTitle: 'Ei raporttia vielä',
      noReportYetDescription:
        'Luo ensimmäinen raporttiluonnos aloittaaksesi tarkastuksen dokumentoinnin.',
      noReportYetSubDescription:
        'Raportti sisältää lukuja, tekstikenttiä ja liitteitä selkeässä rakenteessa.',
      creatingDraft: 'Luodaan luonnosta…',
      createDraft: 'Luo luonnos',

      title: 'Raportti',
      reportGenerationHint1:
        'Raportin luomiseksi tarkastuksen tila on asetettava valmiiksi.',
      reportGenerationHint2: 'Raportit luodaan 15 minuutin välein.',
      reportGenerationHint3:
        'Tiedot haetaan tarkastuksesta, kun tila on asetettu valmiiksi.',

      statusDraft: 'Luonnos',
      statusAiGenerate: 'AI-generointi',
      statusComplete: 'Valmis',

      reportGenerationTitle: 'Raportin luonti',
      reportGenerationLine1:
        'Raportin luomiseksi tarkastuksen tila on asetettava valmiiksi. Raportit luodaan 15 minuutin välein.',
      reportGenerationLine2:
        'Tiedot haetaan tarkastuksesta, kun tila on asetettu valmiiksi.',

      tableOfContents: 'Sisällysluettelo',

      olderVersionWarning:
        'Varoitus! Tarkastelet tämän raportin vanhempaa versiota.',

      saving: 'Tallennetaan…',
      saveReport: 'Tallenna raportti',
      deleteReport: 'Poista raportti',

      confirmDeletionTitle: 'Vahvista poisto',
      confirmDeleteReportMessage: 'Haluatko varmasti poistaa tämän raportin?',
      confirmDeleteTextFieldMessage:
        'Haluatko varmasti poistaa tämän tekstikentän?',

      addField: 'Lisää kenttä',
      fieldSingular: 'kenttä',
      fieldsPlural: 'kenttää',

      aiPrompt: 'AI-kehote',
      reportText: 'Raporttiteksti',
      attachments: 'Liitteet',
      addImage: 'Lisää kuva',

      aiLabel: 'AI',
      scoreLabel: 'Pisteet',

      versionLabel: 'Versio',

      exportToWord: 'Vie Wordiin',
      exportingWord: 'Viedään...',
      wordExportProgress: {
        starting: 'Aloitetaan vienti...',
        capturingCharts: 'Kaapataan kaavioita...',
        capturingDetails: 'Kaapataan laskentatietoja...',
        buildingDocument: 'Luodaan asiakirjaa...',
        savingFile: 'Tallennetaan tiedostoa...',
        complete: 'Vienti valmis',
        error: 'Vienti epäonnistui. Yritä uudelleen.',
      },
    },
    UserCalendar: {
      createYourActivity: 'Luo aktiviteettisi',
      categoryErrorMessage: 'Kategoria puuttuu',
      titleErrorMessage: 'Otsikko puuttuu',
      createActivity: 'Luo aktiviteetti',
      editActivity: 'Muokkaa aktiviteettia',
      confirmDeletion: 'Vahvista poistaminen',
      deleteMessage: 'Haluatko varmasti poistaa tämän aktiviteetin?',
    },
  },
  attachments: {
    notes: 'Muistiinpanot',
    description: 'Kuvaus',
    replaceImage: 'Vaihda kuva',
    addImage: 'Lisää kuva',
    removeAttachment: 'Poista liite',
    tags: 'Aiheet',
    uploadImage: 'Lataa kuvakaappaus',
  },
  buildingControlProfile: {
    inOperationTitle: 'Käytössä',
    outsideOperationTitle: 'Ei käytössä',
    temperatureLower: 'Lämpötilan alaraja (°C)',
    temperatureUpper: 'Lämpötilan yläraja (°C)',
    humidityLower: 'Kosteuden alaraja (%)',
    humidityUpper: 'Kosteuden yläraja (%)',
    co2Tooltip: 'Sallittu CO₂-enimmäistaso, mitattuna ppm.',
    refreshInterval: 'Päivitä väli',
    refreshIntervalHelp: 'Kuinka usein ASPA tarkistaa nämä asetukset.',
    comfortWeight: 'Mukavuuspaino',
    energy: 'Energia',
    comfort: 'Mukavuus',
    costInfo:
      'Optimoija tasapainottaa energiankulutusta ja mukavuutta. Pieni mukavuuspaino priorisoi alhaista energiankulutusta, kun taas suuri mukavuuspaino priorisoi parempaa mukavuutta. Molemmat arvot lasketaan asteikolla 0–1.',
  },
  gridRegions: {
    label: 'Sähköalue',
    placeholder: '- Valitse alue -',
    groups: {
      nordic: 'Pohjoismaat',
      centralEurope: 'Keski-Eurooppa',
      southernEurope: 'Etelä-Eurooppa',
      baltic: 'Baltian maat',
      britishIsles: 'Brittein saaret',
      easternEurope: 'Itä-Eurooppa',
    },
    areas: {
      NO1: 'Oslo / Itä-Norja',
      NO2: 'Kristiansand / Etelä-Norja',
      NO3: 'Trondheim / Keski-Norja',
      NO4: 'Tromssa / Pohjois-Norja',
      NO5: 'Bergen / Länsi-Norja',
      SE1: 'Pohjois-Ruotsi',
      SE2: 'Keski-Pohjois-Ruotsi',
      SE3: 'Keski-Ruotsi',
      SE4: 'Etelä-Ruotsi',
      DK1: 'Länsi-Tanska (Jyllanti-Fyn)',
      DK2: 'Itä-Tanska (Sjælland)',
      FI: 'Suomi',
      DE_LU: 'Saksa-Luxemburg',
      AT: 'Itävalta',
      BE: 'Belgia',
      NL: 'Alankomaat',
      FR: 'Ranska',
      CH: 'Sveitsi',
      CZ: 'Tšekki',
      PL: 'Puola',
      SK: 'Slovakia',
      HU: 'Unkari',
      SI: 'Slovenia',
      HR: 'Kroatia',
      IT_NORTH: 'Italia pohjoinen',
      IT_CNORTH: 'Italia keski-pohjoinen',
      IT_CSOUTH: 'Italia keski-eteläinen',
      IT_SOUTH: 'Italia eteläinen',
      IT_SICILY: 'Italia Sisilia',
      IT_SARDINIA: 'Italia Sardinia',
      ES: 'Espanja',
      PT: 'Portugali',
      GR: 'Kreikka',
      EE: 'Viro',
      LV: 'Latvia',
      LT: 'Liettua',
      GB: 'Iso-Britannia',
      IE_SEM: 'Irlanti (SEM)',
      RO: 'Romania',
      BG: 'Bulgaria',
      RS: 'Serbia',
      ME: 'Montenegro',
      AL: 'Albania',
      MK: 'Pohjois-Makedonia',
      BA: 'Bosnia ja Hertsegovina',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Hae osoitteella',
    placeholder: 'Katu, numero ja paikkakunta',
    moreHint:
      'Näytetään {shown}/{total}. Lisää paikkakunta tai postinumero rajataksesi hakua.',
    noHitsHint:
      'Ei osumia. Lisää talonumero ja paikkakunta, esimerkiksi Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Energiatodistus',
    language: 'Kieli',
    themeLight: 'Vaihda vaaleaan teemaan',
    themeDark: 'Vaihda tummaan teemaan',
    title: 'Energiamerkki',
    loggedInAs: 'Kirjautunut käyttäjänä',
    logout: 'Kirjaudu ulos',
    login: {
      title: 'Kirjaudu sisään',
      phoneDescription:
        'Kirjaudu puhelinnumerolla, jota käytit energiatodistusta (Energiattest) pyytäessäsi. Vahvistuskoodi lähetetään tekstiviestillä.',
      codeDescription: 'Syötä tekstiviestin kuusinumeroinen koodi.',
      phone: 'Puhelinnumero',
      phonePlaceholder: '40 1234567',
      countryCode: 'Maatunnus',
      phoneHint: 'Numero, jonka annoit todistusta pyytäessäsi.',
      code: 'Vahvistuskoodi',
      codeHint: 'Kuusi numeroa tekstiviestistä.',
      codeSentTo: 'Koodi lähetettiin numeroon',
      sendCode: 'Lähetä koodi',
      verify: 'Vahvista',
      changePhone: 'Käytä toista puhelinnumeroa',
    },
    flow: {
      navTitle: 'Näin etenet',
      draftSavedAt: 'Luonnoksesi — viimeksi tallennettu',
      continueLater: 'Voit sulkea ja jatkaa myöhemmin.',
      draft: 'Luonnos',
      saveAndClose: 'Tallenna ja sulje',
      autosaved: 'Vastauksesi tallennetaan automaattisesti.',
      submitted: {
        title: 'Lähetetty',
        body: 'Kiitos. Energianeuvoja käy vastauksesi läpi.',
      },
      back: 'Takaisin',
      next: 'Seuraava',
      submit: 'Lähetä',
      stepsMenu: 'Vaiheet',
      whyWeAsk: 'Miksi kysymme?',
      validation: {
        range: 'Arvon on oltava välillä {min} ja {max}.',
        min: 'Arvon on oltava vähintään {min}.',
        max: 'Arvo voi olla enintään {max}.',
        positive: 'Arvon on oltava yli nollan.',
      },
      select: 'Valitse',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'rakennusnro',
      building: {
        address: 'Osoite',
        buildingNumber: 'Rakennusnro',
        cadastre: 'Gnr / bnr',
        buildingType: 'Rakennustyyppi',
        usableArea: 'Huoneistoala (BRA)',
        footprint: 'Pohjapinta-ala',
      },
      cadastre: {
        notFound:
          'Rakennusta ei löytynyt kiinteistörekisteristä. Täytä se, minkä tiedät.',
      },
      yesNo: { yes: 'Kyllä', no: 'Ei', dontKnow: 'En tiedä' },
      status: {
        completed: 'Valmis',
        defaults: 'Oletusarvot',
        notApplicable: 'Ei sovellu',
      },
      steps: {
        confirmBuilding: {
          nav: 'Vahvista rakennus',
          title: 'Vahvista rakennus',
          eyebrow: 'Löydetty GPS:n ja kiinteistörekisterin avulla',
          question: 'Onko tämä sinun rakennuksesi?',
          body: 'Olemme merkinneet sijaintiasi lähimmän rakennuksen. Tarkista, että osoite ja rakennusnumero ovat oikein, ennen kuin jatkat.',
          wrongHint:
            'Eikö täsmää? Napauta oikeaa rakennusta kartalla tai hae osoitteella.',
          searchAddress: 'Hae osoitteella',
          mapTitle: 'Rakennuksen valinta',
          noBuilding:
            'Täältä ei löytynyt rakennusta. Vedä merkki lähemmäs rakennusta.',
        },
        aboutBuilding: {
          nav: 'Tietoja rakennuksesta',
          title: 'Tietoja rakennuksesta',
          lead: 'Suurin osa alla olevista tiedoista on haettu kiinteistörekisteristä. Korjaa se, mikä ei täsmää — todistus perustuu näihin lukuihin.',
          aside: {
            title: 'Luokka, rakennusvuosi ja pinta-ala',
            body: 'Rakennusluokka, rakennusvuosi ja kerrosala ovat koko laskennan perusta. Luokka määrää oletusarvot, rakennusvuosi kertoo, mitkä rakentamismääräykset olivat voimassa, ja pinta-ala ratkaisee, kuinka paljon energiaa rakennus käyttää neliömetriä kohden.',
          },
          sections: {
            category: {
              title: 'Rakennusluokka',
              description:
                'Luokka määrää, mitä oletusarvoja käytetään myöhemmin.',
            },
            area: {
              title: 'Pinta-ala ja korkeus',
              description: 'Pohjapinta-alan voi lukea myös kartalta.',
            },
          },
          fields: {
            category: {
              label: 'Luokka',
              hint: 'Haettu kiinteistörekisteristä, jos rakennus löytyy sieltä.',
            },
            subcategory: {
              label: 'Alaluokka',
              hint: 'Haettu kiinteistörekisteristä, jos rakennus löytyy sieltä.',
            },
            buildYear: {
              label: 'Rakennusvuosi',
              hint: 'Rakentamisen aloitusvuosi, jos tiedossa.',
            },
            floors: {
              label: 'Kerrosten määrä',
              hint: 'Maanpinnan yläpuolella. Kellari lisätään myöhemmin.',
            },
            footprint: {
              label: 'Pohjapinta-ala',
              hint: 'Kiinteistörekisteristä tai kartalta.',
            },
            usableArea: {
              label: 'Kokonaishuoneistoala (BRA)',
              hint: 'Kaikkien kerrosten yhteenlaskettu lattiapinta-ala ulkoseinien sisäpuolelta mitattuna.',
            },
            heatedArea: {
              label: 'Lämmitetty huoneistoala',
              hint: 'Ala, joka lämmitetään yli 15 °C:seen.',
            },
            floorHeight: {
              label: 'Keskimääräinen kerroskorkeus',
              hint: 'Jätä tyhjäksi, jos et tiedä, jolloin käytetään kategorian vakioarvoa.',
            },
          },
          options: {
            categories: {
              kontor: 'Toimistorakennus',
              lettIndustri: 'Kevyt teollisuus',
              lager: 'Varastorakennus',
              forretning: 'Liikerakennus',
              skole: 'Koulurakennus',
              hotell: 'Hotellirakennus',
            },
            subcategories: {
              lettindustriLager: 'Kevyt teollisuus ja varasto',
              verksted: 'Korjaamo',
              produksjon: 'Tuotantohalli',
            },
          },
          knowMore: 'Tiedätkö enemmän pinta-aloista?',
        },
        envelope: {
          nav: 'Ulkovaippa',
          title: 'Ulkovaippa',
          lead: 'Ulkoseinien rakenne määrää, kuinka paljon lämpöä rakennus menettää. Valitse lähimpänä oleva vaihtoehto.',
          sections: {
            walls: {
              title: 'Ulkoseinät',
              description:
                'Materiaali ja paksuus määräävät, kuinka paljon lämpöä seinät päästävät ulos.',
            },
            more: {
              title: 'Mitä muuta rakennuksessa on?',
              description:
                'Tässä valitsemasi kohdat avaavat omat vaiheensa valikkoon.',
            },
          },
          fields: {
            construction: {
              label: 'Rakenne',
              hint: 'Yleisin tyyppi, jos niitä on useita.',
            },
            insulation: {
              label: 'Eristeen paksuus',
              hint: 'Jätä tyhjäksi, jos et tiedä — käytämme rakennusvuoden standardia.',
            },
          },
          options: {
            walls: {
              tre: 'Puu',
              mur: 'Tiili',
              staal: 'Teräs',
              betong: 'Betoni',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Kellari tai alakerros' },
            knowWindows: { label: 'Ikkunat' },
            doors: { label: 'Ovet' },
            gates: { label: 'Portit' },
          },
          aside: {
            title: 'Seinät ja lämpöhäviö',
            body: 'Suuri osa rakennuksen lämmöstä karkaa seinien kautta. Materiaali ja eristys kertovat neuvojalle, kuinka hyvin rakennus pitää lämmön sisällään. Valitse lähimpänä oleva vaihtoehto, neuvoja laskee loput.',
          },
        },
        basement: {
          nav: 'Kellari',
          title: 'Kellari',
          lead: 'Alakerros lasketaan eri tavalla, koska se rajautuu maahan eikä ulkoilmaan.',
          aside: {
            title: 'Kellari maata vasten',
            body: 'Kellari rajautuu maahan, ei ulkoilmaan. Maan lämpötila pysyy tasaisempana ympäri vuoden, joten lämpöhäviö lasketaan eri tavalla kuin maanpäällisillä seinillä. Se, onko kellari lämmitetty, ratkaisee, lasketaanko se mukaan lämmitettyyn pinta-alaan. Täytä se, mitä tiedät, tyhjät kentät saavat oletusarvot.',
          },
          section: {
            title: 'Alakerros',
            description:
              'Vain se, mitä tiedät. Tyhjät kentät saavat oletusarvot.',
          },
          checks: {
            heated: {
              label: 'Alakerros on lämmitetty',
              description:
                'Lämmittämätön kellari lasketaan puskuriksi maata vastaan.',
            },
          },
          fields: {
            floorArea: { label: 'Kellarin lattiapinta-ala' },
            wallLength: { label: 'Ulkoseinien pituus' },
            floorHeight: { label: 'Kerroskorkeus' },
            wallThickness: { label: 'Kellarin seinän paksuus' },
            depth: {
              label: 'Keskimääräinen syvyys maanpinnan alapuolella',
              hint: 'Kuinka syvällä kellari on maastossa.',
            },
          },
          knowMore: 'Tiedätkö enemmän kellarista?',
        },
        windows: {
          nav: 'Ikkunat',
          title: 'Ikkunat',
          lead: 'Ikkunat vastaavat suuresta osasta lämpöhäviötä — ja aurinkolämpöä. Jakauma ilmansuuntien mukaan merkitsee eniten.',
          sections: { area: { title: 'Rakennuksen ikkunat' } },
          checks: {
            even: {
              label: 'Kaikki ikkunat ovat jakautuneet tasaisesti rakennukseen',
              description:
                'Jaamme kokonaispinta-alan tasan neljälle julkisivulle.',
            },
          },
          fields: {
            windowType: {
              label: 'Ikkunatyyppi',
              hint: 'Yleisin tyyppi, jos niitä on useita.',
            },
            totalArea: { label: 'Ikkunoiden kokonaispinta-ala' },
            installYear: {
              label: 'Ikkunoiden asennusvuosi',
              hint: 'Vuosi, jolloin uusimmat ikkunat asennettiin.',
            },
            north: { label: 'Pohjoinen' },
            east: { label: 'Itä' },
            south: { label: 'Etelä' },
            west: { label: 'Länsi' },
          },
          aside: {
            title: 'Ilmansuunta',
            body: 'Etelään suunnatut ikkunat päästävät sisään eniten aurinkolämpöä ja vähentävät lämmitystarvetta. Pohjoiseen päin on lähes pelkkää lämpöhäviötä. Siksi kysymme julkisivua kohti.',
          },
          knowMore: 'Tiedätkö enemmän ikkunoista?',
        },
        doors: {
          nav: 'Ovet ja portit',
          title: 'Ovet ja portit',
          lead: 'Ovet ja portit ovat osa rakennuksen vaippaa, ja tyyppi kertoo paljon lämpöhäviöstä. Täytä se, mitä tiedät tai muistat, loput saavat oletusarvot.',
          only: {
            doors: {
              nav: 'Ovet',
              title: 'Ovet',
              lead: 'Ulko-ovet ovat osa rakennuksen vaippaa, ja tyyppi kertoo paljon lämpöhäviöstä. Täytä se, mitä tiedät tai muistat, loput saavat oletusarvot.',
              aside: {
                title: 'Ovet ja lämpöhäviö',
                body: 'Ulko-ovi päästää enemmän lämpöä läpi kuin ympäröivä seinä. Ovityyppi kertoo neuvojalle suunnilleen, kuinka hyvin se eristää. Sen, mitä et tiedä, neuvoja laskee rakennusvuoden ja oletusarvojen perusteella.',
              },
            },
            gates: {
              nav: 'Portit',
              title: 'Portit',
              lead: 'Portit ovat usein rakennuksen vaipan suurimmat aukot, ja tyyppi kertoo paljon lämpöhäviöstä. Täytä se, mitä tiedät tai muistat, loput saavat oletusarvot.',
              aside: {
                title: 'Portit ja lämpöhäviö',
                body: 'Portit ovat usein rakennuksen suurimmat aukot, ja ne ovat usein auki pitkiäkin aikoja. Porttityyppi kertoo neuvojalle suunnilleen, kuinka hyvin ne eristävät. Sen, mitä et tiedä, neuvoja laskee rakennusvuoden ja oletusarvojen perusteella.',
              },
            },
          },
          aside: {
            title: 'Ovet, portit ja lämpöhäviö',
            body: 'Ovet ja portit päästävät enemmän lämpöä läpi kuin ympäröivä seinä, ja portit ovat usein auki pitkiäkin aikoja. Tyyppi kertoo neuvojalle suunnilleen, kuinka hyvin ne eristävät. Sen, mitä et tiedä, neuvoja laskee rakennusvuoden ja oletusarvojen perusteella.',
          },
          sections: {
            doors: {
              title: 'Ovet',
              description: 'Ulko-ovet henkilöliikenteelle.',
            },
            gates: {
              title: 'Portit',
              description: 'Ajoneuvoportit, lastausportit ja vastaavat.',
            },
          },
          fields: {
            doorType: {
              label: 'Ovityyppi',
              hint: 'Yleisin tyyppi, jos niitä on useita.',
            },
            installYear: { label: 'Asennusvuosi' },
            uValue: {
              label: 'U-arvo, keskiarvo',
              hint: 'Jätä tyhjäksi, jos et tiedä.',
            },
            gateType: {
              label: 'Porttityyppi',
              hint: 'Yleisin tyyppi, jos niitä on useita.',
            },
            area: { label: 'Pinta-ala' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Teräsovi',
              glass: 'Lasiovi',
              tre: 'Puuovi',
              aluminium: 'Alumiiniovi',
            },
            gateTypes: {
              leddportIsolert: 'Eristetty nosto-ovi',
              leddport: 'Eristämätön nosto-ovi',
              rulleport: 'Rullaovi',
              hurtigport: 'Pikaovi',
            },
          },
          knowMoreDoors: 'Tiedätkö enemmän ovista?',
          knowMoreGates: 'Tiedätkö enemmän porteista?',
        },
        energySources: {
          nav: 'Energialähteet',
          title: 'Energialähteet',
          lead: 'Mitä energialähteitä rakennuksessa on? Tässä tehdyt valinnat avaavat seuraavat vaiheet.',
          sections: {
            delivered: {
              title: 'Ostoenergia',
              description: 'Valitse kaikki, mikä on liitetty rakennukseen.',
            },
            own: { title: 'Oma tuotanto' },
          },
          checks: {
            electricity: {
              label: 'Sähkö',
              description:
                'Kaikissa rakennuksissa on sähkö. Pelkkä sähkö antaa yksinkertaistetun laskennan.',
            },
            districtHeating: {
              label: 'Kaukolämpö',
              description: 'Avaa vaiheen Keskuslämmitysjärjestelmä.',
            },
            heatPump: {
              label: 'Lämpöpumppu',
              description: 'Avaa vaiheen Lämpöpumppu.',
            },
            fossil: {
              label: 'Öljy, kaasu tai bio',
              description: 'Avaa vaiheen Polttokattila.',
            },
            other: {
              label: 'Muut energialähteet',
              description: 'Kuvaile viimeisen vaiheen kommenttikentässä.',
            },
            solar: {
              label: 'Rakennuksessa on aurinkosähköjärjestelmä',
              description: 'Avaa vaiheen Aurinkopaneelit.',
            },
          },
          aside: {
            title: 'Keskuslämmitys',
            body: 'Kaukolämpö, lämpöpumppu ja kattilat voivat kaikki olla liitettynä yhteen keskuslämmitysjärjestelmään. Seuraavassa vaiheessa kysymme, miten ne jakavat lämmityksen ja lämpimän käyttöveden.',
          },
        },
        centralHeating: {
          nav: 'Keskuslämmitysjärjestelmä',
          title: 'Keskuslämmitysjärjestelmä',
          lead: 'Valitut energialähteet — näin ne on kytketty keskuslämmitysjärjestelmään.',
          sections: {
            plant: { title: 'Järjestelmä' },
            districtHeating: {
              title: 'Kaukolämpö',
              description: 'Näin kaukolämpöä käytetään rakennuksessa.',
            },
          },
          fields: {
            location: { label: 'Sijainti', hint: 'Missä lämmönjakohuone on.' },
            installYear: { label: 'Asennusvuosi' },
            connectedTo: {
              label: 'Liitetty',
              hint: 'Minne vesi kulkee.',
            },
          },
          options: {
            locations: {
              tekniskRom: 'Tekninen tila',
              kjeller: 'Kellari',
              tak: 'Katto',
              egetBygg: 'Erillinen rakennus',
            },
            connections: {
              oppvarming: 'Lämmitys',
              oppvarmingVent: 'Lämmitys ja ilmanvaihto',
            },
          },
          checks: {
            forHeating: { label: 'Tilojen lämmitys' },
            forHotWater: { label: 'Käyttövesi' },
          },
          aside: {
            title: 'Lämpö jaetaan keskukselta',
            body: 'Keskuslämmitysjärjestelmä kuljettaa energialähteiden lämmön rakennukseen vetenä. Se, missä keskus sijaitsee ja lämmittääkö vesi myös ilmanvaihdon ilmaa, ratkaisee, kuinka paljon lämpöä häviää matkalla. Jos tiedot puuttuvat, käytämme oletusarvoja.',
          },
        },
        heatPump: {
          nav: 'Lämpöpumppu',
          title: 'Lämpöpumppu',
          lead: 'Lämpöpumpun tyyppi ja suorituskyky. Teho ja kulutus löytyvät yleensä tyyppikilvestä tai huoltokirjasta.',
          sections: {
            plant: { title: 'Järjestelmä' },
            connection: { title: 'Kytkentä' },
          },
          fields: {
            type: { label: 'Tyyppi' },
            installYear: { label: 'Asennusvuosi' },
            power: {
              label: 'Teho',
              hint: 'Nimellinen lämmitysteho tyyppikilvestä.',
            },
            annualUse: {
              label: 'Vuosikulutus',
              hint: 'Sähkömittarista tai ohjausjärjestelmästä, jos saatavilla.',
            },
          },
          options: {
            types: {
              luftLuft: 'Ilma–ilma',
              luftVann: 'Ilma–vesi',
              vaeskeVann: 'Neste–vesi',
              avtrekk: 'Poistoilmalämpöpumppu',
            },
          },
          checks: {
            connected: {
              label: 'Lämpöpumppu on liitetty keskuslämmitysjärjestelmään',
              description: 'Osuus asetetaan vaiheessa Lämmitys ja jäähdytys.',
            },
          },
          knowMore: 'Tiedätkö enemmän lämpöpumpusta?',
          aside: {
            title: 'Enemmän lämpöä kuin sähköä',
            body: 'Lämpöpumppu ottaa lämpöä ilmasta, vedestä tai maasta ja tuottaa enemmän kilowattitunteja lämpöä kuin se kuluttaa sähköä. Tyyppi, teho ja ikä ratkaisevat sen tehokkuuden, ja se vaikuttaa suoraan energialuokkaan. Jos luvut puuttuvat, käytämme oletusarvoja.',
          },
        },
        boiler: {
          nav: 'Polttokattila',
          title: 'Polttokattila',
          lead: 'Kattila, jota lämmitetään öljyllä, kaasulla tai biomassalla. Teho löytyy yleensä tyyppikilvestä.',
          sections: { plant: { title: 'Kattila' } },
          fields: {
            fuelType: { label: 'Kattilatyyppi' },
            power: {
              label: 'Teho täydellä kuormalla',
              hint: 'Tyyppikilvestä tai dokumentaatiosta.',
            },
          },
          options: {
            fuelTypes: { olje: 'Öljy', gass: 'Kaasu', bio: 'Biomassa' },
          },
          aside: {
            title: 'Polttoaine painaa eri tavalla',
            body: 'Öljy, kaasu ja biomassa painotetaan energiatodistuksessa eri tavoin, joten kattilatyyppi vaikuttaa sekä energialuokkaan että lämmitysarvosanaan. Teho kertoo, kuinka suuren osan lämmöntarpeesta kattila voi kattaa. Jos luvut puuttuvat, käytämme oletusarvoja.',
          },
        },
        solar: {
          nav: 'Aurinkopaneelit',
          title: 'Aurinkopaneelit',
          lead: 'Itse tuotettu sähkö vähennetään ostoenergiasta todistuksessa.',
          sections: {
            plant: {
              title: 'Aurinkosähköjärjestelmä',
              description:
                'Luvut löytyvät yleensä toimittajan dokumentaatiosta tai järjestelmän sovelluksesta.',
            },
            hotWater: { title: 'Lämmin käyttövesi' },
          },
          fields: {
            installedPower: {
              label: 'Asennettu teho',
              hint: 'Löytyy järjestelmän dokumentaatiosta.',
            },
            installYear: { label: 'Asennusvuosi' },
            annualProduction: {
              label: 'Vuosituotanto',
              hint: 'Invertteristä tai järjestelmän sovelluksesta.',
            },
            panelArea: { label: 'Paneelipinta-ala' },
          },
          checks: {
            hotWaterConnected: {
              label: 'Lämmin käyttövesi on liitetty keskusjärjestelmään',
              description:
                'Katso energialähteet. Muuten lämmin käyttövesi lasketaan sähköiseksi.',
            },
          },
          aside: {
            title: 'Oma sähkö lasketaan hyödyksi',
            body: 'Aurinkopaneelien sähkö kattaa osan rakennuksen kulutuksesta, ja se voi parantaa energialuokkaa. Siksi meidän täytyy tietää, kuinka suuri järjestelmä on. Jos luvut puuttuvat, kerro siitä viimeisen vaiheen kommenttikentässä.',
          },
          knowMore: 'Tiedätkö enemmän aurinkosähköjärjestelmästä?',
        },
        ventilation: {
          nav: 'Ilmanvaihto',
          systemTitle: 'Kone {number}',
          title: 'Ilmanvaihto',
          lead: 'Onko rakennuksessa ilmanvaihtokone?',
          sections: {
            type: {
              title: 'Ilmanvaihtokone',
              description:
                'Vain koneellinen tulo- ja poistoilmanvaihto vaatii lisätietoja.',
            },
            plant: {
              title: 'Kone',
              description:
                'Kone puhaltaa raikasta ilmaa sisään ja poistaa käytetyn ilman, usein lämmöntalteenotolla.',
            },
            capacity: {
              title: 'Kapasiteetti — konetta kohti',
              description:
                'Jos kapasiteetti on vähimmäisarvoa suurempi, se on ilmoitettava.',
            },
            maintenance: { title: 'Huolto' },
          },
          fields: {
            hasSystems: { label: 'Onko rakennuksessa ilmanvaihtokone?' },
            count: {
              label: 'Koneiden määrä',
              hint: 'Saat oman kenttäryhmän jokaiselle koneelle.',
            },
            type: { label: 'Tyyppi' },
            installYear: { label: 'Asennusvuosi' },
            airflowOperating: { label: 'Ilmavirta käyttöaikana' },
            airflowOff: { label: 'Ilmavirta käyttöajan ulkopuolella' },
            lastMaintenance: {
              label: 'Viimeisin huoltopäivä',
              hint: 'Huoltoraportista.',
            },
            regularMaintenance: {
              label: 'Huolletaanko konetta säännöllisesti?',
            },
            moreInfo: {
              label: 'Onko sinulla lisätietoa ilmanvaihdosta neuvojalle?',
              hint: 'Suodattimien vaihto, käyttöajat, tunnetut poikkeamat.',
            },
            heatRecovery: {
              label: 'Lämmöntalteenoton hyötysuhde',
              hint: 'Koneen dokumentaatiosta.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label: 'Jäteilmalämpöpumppu liitetty keskukseen',
            },
            extractHeatPump: {
              label: 'Poistoilmalämpöpumppu liitetty keskukseen',
            },
          },
          options: {
            types: {
              avtrekk: 'Koneellinen poisto',
              balansert: 'Koneellinen tulo- ja poistoilmanvaihto',
            },
            typeDescriptions: {
              avtrekk: 'Suurella osalla rakennusta on koneellinen poisto.',
            },
          },
          aside: {
            title: 'Ilma ja lämpö',
            body: 'Ilmanvaihto vaihtaa käytetyn sisäilman raikkaaseen ulkoilmaan. Järjestelmä, joka ottaa lämmön talteen poistoilmasta, säästää paljon energiaa. Jos luvut puuttuvat, käytämme oletusarvoja.',
          },
          knowMore: 'Tiedätkö enemmän ilmanvaihdosta?',
        },
        heating: {
          nav: 'Lämmitys ja jäähdytys',
          title: 'Lämmitys ja jäähdytys',
          lead: 'Alla olevat ehdotukset perustuvat valitsemiisi energialähteisiin ja ilmanvaihtoon. Täytä osuus, jonka kukin ratkaisu kattaa, jos tiedät sen.',
          groups: {
            electric: { title: 'Sähkölämmitys' },
            central: { title: 'Keskuslämmitys' },
          },
          options: {
            electric: {
              panelHeaters: 'Paneelilämmittimet',
              convectors: 'Konvektorit',
              electricBoiler: 'Sähkökattila lämminvesivaraajalla',
              electricFloor: 'Lattialämmitys',
              ventilationHeat: 'Ilmanvaihtolämmitys',
              airToAir: 'Ilma–ilmalämpöpumppu',
            },
            central: {
              radiators: 'Patterit',
              convectors: 'Konvektorit',
              waterFloor: 'Lattialämmitys',
              ventilationHeat: 'Ilmanvaihtolämmitys',
            },
          },
          sections: { cooling: { title: 'Jäähdytys' } },
          checks: {
            hasCooling: {
              label: 'Rakennuksessa on jäähdytys',
              description:
                'Jäähdytyskone, kaukojäähdytys tai lämpöpumppu jäähdytystilassa.',
            },
          },
          aside: {
            title: 'Täytä se, minkä tiedät',
            body: 'Jos et tiedä, kenttiä ei tarvitse täyttää. Täytä se, minkä tiedät, mistä tiedät jotain tai likimääräiset arvot. Lisätiedot antavat energianeuvojalle paremman perustan.',
          },
          singleShare: 'Oletamme, että tämä kattaa koko lämmityksen.',
        },
        summary: {
          nav: 'Yhteenveto ja lähetys',
          title: 'Yhteenveto ja lähetys',
          lead: 'Energiatodistus on tarkempi — ja usein parempi — kun useampi kenttä on täytetty.',
          alert: {
            title: '{count} vaihetta käyttää oletusarvoja',
            body: 'Puutteellisten lähtötietojen vuoksi energiamerkintä tehdään rajallisen tiedon pohjalta. Osa teknisistä järjestelmistä ja rakennuksesta lasketaan silloin oletusarvojen mukaan. Voit lähettää nyt tai palata täyttämään lisää tarkempaa merkintää varten.',
          },
          registered: 'Rekisteröimäsi tiedot',
          confirmFirst:
            'Vahvista ennen lähettämistä, että tiedot on annettu vilpittömästi.',
          sections: { advisor: { title: 'Neuvojalle' } },
          fields: {
            note: {
              label:
                'Onko jotain, mitä neuvojan tulisi tietää energiavirroista ja kulutuksesta?',
              hint: 'Esimerkiksi: osa rakennuksesta on tyhjillään, yö- ja viikonloppupudotus, äskettäiset vaihdot, tunnetut vuodot.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'Kaikki tiedot on annettu parhaan ymmärryksen mukaan ja hyvässä uskossa',
              description:
                'Neuvoja käyttää vastauksiasi energiatodistuksen pohjana. Voit korjata myöhemmin, jos jokin oli väärin.',
            },
          },
          aside: {
            eyebrow: 'Mitä seuraavaksi?',
            title: 'Rekisteröintisi menee neuvojalle',
            body: 'Energianeuvoja tarkistaa vastauksesi ja lähettää energiatodistuksen Enovalle. Kenenkään ei tarvitse käydä rakennuksessa. Saat ilmoituksen, kun todistus on valmis.',
          },
        },
      },
      knowInstallYear: 'Tiedätkö asennusvuoden?',
      assumeBuildYear: 'Oletamme asennusvuodeksi {year}.',
      buildYearWord: 'rakennusvuoden',
      assumeStandard: 'Oletamme vakioarvot.',
    },
  },
};

export default FINNISH;
